import { Accordion, AccordionTab } from "primereact/accordion";
import { Tooltip } from "primereact/tooltip";
import React, { useEffect, useRef, useState } from "react";
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import { getCustomer } from "../../../../Services/customerServices";
import DropdownElement from "../../../../Components/UiComponents/DropdownElement";
import TextareaElement from "../../../../Components/UiComponents/TextareaElement";
import RadioElement from "../../../../Components/UiComponents/RadioElement";
import CalendarElement from "../../../../Components/UiComponents/CalendarElement";
import InputTextElementElement from "../../../../Components/UiComponents/InputTextElement";
import MultiSelectElement from "../../../../Components/UiComponents/MultiSelectElement";
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import DataTable from "../../../../Components/UiComponents/DataTable";
import { Dialog } from "primereact/dialog";
import CheckboxElement from "../../../../Components/UiComponents/CheckboxElement";
import { Paginator } from "primereact/paginator";
import {
  downloadDocs,
  generateRiskReport,
  riskActionComplete,
} from "../../../../Services/opportunityService";
import _ from "lodash";
import { useOpportunity } from "../../../../Providers/OpportunityContext";
import { InputIcon } from "primereact/inputicon";
import Loader from "../../../../Components/UiComponents/Loader";
import { useForm, Controller } from "react-hook-form";
import socket from "../../../../socket";
import { clearCompletedNotification } from "../../../../Services/notificationService";
import { useNavigate } from "react-router-dom";
import PlaylistVideos from "../../../../Components/Videos/PlaylistVideos";

const Risks = ((props) => {
  const {
    formState: { errors },
    control,
  } = useForm();

  const [propsData, setPropsData] = useState(props);
  const [insuranceCoverRadio, setInsuranceCoverRadio] = useState("");
  const [totalRiskScoreByCat, setTotalRiskScoreByCat] = useState({
    riskSum: 0,
    riskOppSum: 0,
  });
  const [customerTooltipData, setCustomerTooltipData] = useState([]);
  const navigate = useNavigate()
  const [opportunityIdentification, setOpportunityIdentification] = useState(
    []
  );
  const [filterOpportunityIdentification, setFilterOpportunityIdentification] =
    useState([]);
  const [statusFilter, setStatusFilter] = useState([
    { _id: 1, label: "Completed", value: true },
    { _id: 2, label: "Incomplete", value: false },
  ]);
  const { globalOpportunityData, setGlobalOpportunityData } = useOpportunity();
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDropdown1, setShowDropdown1] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedStatus1, setSelectedStatus1] = useState([]);
  const [selectedOwnerResp, setSelectedOwnerResp] = useState([]);
  const [selectedOwnerResp1, setSelectedOwnerResp1] = useState([]);
  const [riskTypeData, setRiskTypeData] = useState([]);
  const [OppScoreByCat, setOppScoreByCat] = useState({});
  const [oppCount, setOppCount] = useState({ Low: 0, Medium: 0, High: 0 });
  const [riskScoreByCat, setRiskScoreByCat] = useState({});
  const [actionOwners, setActionOwners] = useState([]);
  const [internBidTeamUsers, setInternBidTeamUsers] = useState([]);
  const [actionOwnersFilter, setActionOwnersFilter] = useState([]);
  const [internBidUserFilter, setInternBidUserFilter] = useState([]);
  const [riskCount, setRiskCount] = useState({ Low: 0, Medium: 0, High: 0 });
  const [OppScoreLength, setOppScoreLength] = useState(0);
  const [riskCategory, setRiskCategory] = useState([]);
  const [checkedIdentifications, setCheckedIdentifications] = useState([]);
  const [selectedToView, setSelectedToView] = useState([]);
  const [selectedToView1, setSelectedToView1] = useState([]);
  const [selectedOppManagementToView, setSelectedOppManagementToView] =
    useState(null);
  const [selectedRiskToView, setSelectedRiskToView] = useState([]);
  const [selectedGroupToView, setSelectedGroupToView] = useState("");
  const [selectedRiskGroupIndex, setSelectedRiskGroupIndex] = useState(0);
  const [openOppIdentification, setOpenOppIdentification] = useState(false);
  const [openOppManagement, setOpenOppManagement] = useState(false);
  const [openRiskIdentification, setOpenRiskIdentification] = useState(false);
  const [openEditRiskIdentification, setOpenEditRiskIdentification] =
    useState(false);
  const [openEditOppManagement, setOpenEditOppManagement] =
    useState(false);
  const [oppManageIndex, setOppManageIndex] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [riskDetails, setRiskDetails] = useState([]);
  const [riskTypemodel, setRiskTypemodel] = useState([]);
  const [riskGroups, setRiskGroups] = useState([]);
  const [filteredRiskGroups, setFilteredRiskGroups] = useState([]);
  //   const [riskCount, setRiskCount] = useState({ Low: 0, Medium: 0, High: 0 });
  const [loading, setLoading] = useState(false);
  const [currentRowId, setCurrentRowId] = useState(null);
  const [currentGroup, setCurrentGroup] = useState(null);
  const [isCompletedState, setIsCompletedState] = useState(false);
  const [completedIndex, setCompletedIndex] = useState(0);
  const [isCompletedPopup, setIsCompletedPopup] = useState(false);
  const [isCompletedData, setIsCompletedData] = useState(null);
  const [notIsCompletedPopup, setNotIsCompletedPopup] = useState(false);
  const [notIsCompletedData, setNotIsCompletedData] = useState(null);
  const [isCompletedPopup1, setIsCompletedPopup1] = useState(false);
  const [isCompletedData1, setIsCompletedData1] = useState(null);
  const [notIsCompletedPopup1, setNotIsCompletedPopup1] = useState(false);
  const [notIsCompletedData1, setNotIsCompletedData1] = useState(null);
  const [groupForPopup, setGroupForPopup] = useState(null);
  const [isOppCompletedState, setIsOppCompletedState] = useState(false);
  const [oppCompletedIndex, setOppCompletedIndex] = useState(0);
  const [openEditOppIdentification, setOpenEditOppIdentification] =
    useState(false);
  const [oppIdentifyIndex, setOppIdentifyIndex] = useState(0);
  const [showVideo, setShowVideo] = useState(false);
  const toastRef = useRef();

  const userprivileges = localStorage.getItem("user_privileges");
  if (userprivileges) {
    var tmpPrivilege = JSON.parse(userprivileges);
    if (tmpPrivilege !== undefined && tmpPrivilege !== null) {
      var teamEditPrivilege = tmpPrivilege[0].bid_team_edit;
    }
  }

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  useEffect(() => {
    if (totalRiskScoreByCat) {
      props.riskScore(totalRiskScoreByCat)
    }
  }, [totalRiskScoreByCat])

  useEffect(() => {
    setPropsData(props);
  }, [props]);

  useEffect(() => {
    setOpportunityIdentification(
      props.opportunityData.opportunity_identification
    );
    setFilterOpportunityIdentification(
      props.opportunityData.opportunity_identification
    );
  }, [props.opportunityData.opportunity_identification]);

  useEffect(() => {
    setRiskCategory(propsData.riskCategory);
  }, [propsData.riskCategory]);

  useEffect(() => {
    calcTotalRiskScore();
  }, [riskGroups, propsData.opportunityData.risk_identification, propsData.riskCategory, propsData.riskType, globalOpportunityData]);

  useEffect(() => {
    setGlobalOpportunityData((prevData) => ({
      ...prevData,
      opportunity_identification: opportunityIdentification,
    }));
  }, [opportunityIdentification]);

  useEffect(() => {
    setInsuranceCoverRadio(
      propsData.opportunityData?.additional_considerations?.insurance_cover
    );
  }, [propsData.opportunityData?.additional_considerations?.insurance_cover]);

  useEffect(() => {
    getCustomerData();
  }, [props.customerId]);

  useEffect(() => {
    const loadRiskOppDetails = () => {
      const oppCount = {
        Low: 0,
        Medium: 0,
        High: 0,
      };
      const updatedOpportunityIdentification =
        propsData.opportunityData?.opportunity_identification?.map((item) => {
          const risk = propsData.riskCategory.find(
            (category) => category._id === item.category
          );

          if (risk) {
            const selLikelihood =
              item.likelihood !== undefined ? item.likelihood : 0;
            const selImpact = item.impact !== undefined ? item.impact : 0;
            const riskScore = selImpact * selLikelihood;

            let riskColor;
            if (riskScore >= 1 && riskScore <= 4) {
              riskColor = "#008000";
              oppCount.Low += 1;
            } else if (riskScore >= 5 && riskScore <= 14) {
              riskColor = "#ffa500";
              oppCount.Medium += 1;
            } else if (riskScore >= 15 && riskScore <= 25) {
              riskColor = "#ff0000";
              oppCount.High += 1;
            } else {
              riskColor = "none";
            }

            return {
              ...item,
              opp_score: riskScore,
              risk_color: riskColor,
              opp_CatLabel: risk.label,
            };
          }
          return item;
        });
      setOpportunityIdentification(updatedOpportunityIdentification);
      setFilterOpportunityIdentification(updatedOpportunityIdentification);

      setOppCount(oppCount);
      calcTotalOppScore();
    };

    loadRiskOppDetails();
  }, [propsData.opportunityData, propsData.riskCategory]);

  const oppCatChange = (e, selectedRow, index) => {
    setOpportunityIdentification((prevOpp) =>
      prevOpp.map((item, ind) =>
        ind === index
          ? { ...item, opp_CatLabel: e.target.value.label, category: e.target.value._id }
          : item
      )
    );
    setFilterOpportunityIdentification((prevOpp) =>
      prevOpp.map((item, ind) =>
        ind === index
          ? { ...item, opp_CatLabel: e.target.value.label, category: e.target.value._id }
          : item
      )
    );
  };

  const oppActionOwnerChange = (e, selectedRow, index) => {
    setOpportunityIdentification((prevOpp) =>
      prevOpp.map((item, ind) =>
        ind === index
          ? { ...item, action_owner: e.target.value._id }
          : item
      )
    );
    setFilterOpportunityIdentification((prevOpp) =>
      prevOpp.map((item, ind) =>
        ind === index
          ? { ...item, action_owner: e.target.value._id }
          : item
      )
    );
  };

  const oppCatChange1 = (e, selectedRow, group, index) => {
    const selectedCategoryId = e.target.value._id;
    const selectedCategoryLabel = e.target.value.label;

    const riskCat = propsData.riskCategory.find(
      (obj) => obj._id === selectedCategoryId
    );

    if (riskCat) {
      var tmpFactor = group + "##" + riskCat.label;
      const tmpOpts = _.filter(
        _.find(propsData.data, { display_name: tmpFactor }).option_choice,
        { status: "active" }
      );

      setRiskGroups((prevGroups) => {
        const updatedGroups = { ...prevGroups };

        updatedGroups[group] = updatedGroups[group].map((item, ind) =>
          ind === index
            ? {
              ...item,
              risk_category: selectedCategoryId,
              risk_catLabel: selectedCategoryLabel,
              factor_opt: tmpOpts.length > 0 ? tmpOpts : item.factor_opt,
            }
            : item
        );

        return updatedGroups;
      });

      setFilteredRiskGroups((prevGroups) => {
        const updatedGroups = { ...prevGroups };

        updatedGroups[group] = updatedGroups[group].map((item, ind) =>
          ind === index
            ? {
              ...item,
              risk_category: selectedCategoryId,
              risk_catLabel: selectedCategoryLabel,
              factor_opt: tmpOpts.length > 0 ? tmpOpts : item.factor_opt,
            }
            : item
        );

        return updatedGroups;
      });
    }
    calcTotalRiskScore();
  };

  const oppFactorChange = (e, selectedRow, group, index) => {
    const selectedFactorId = e.target.value._id;

    setRiskGroups((prevGroups) => {
      const updatedGroups = { ...prevGroups };

      updatedGroups[group] = updatedGroups[group].map((item, ind) =>
        ind === index
          ? { ...item, risk_factor: selectedFactorId }
          : item
      );

      return updatedGroups;
    });

    setFilteredRiskGroups((prevGroups) => {
      const updatedGroups = { ...prevGroups };

      updatedGroups[group] = updatedGroups[group].map((item, ind) =>
        ind === index
          ? { ...item, risk_factor: selectedFactorId }
          : item
      );

      return updatedGroups;
    });
  };

  const onOppCategoryChange = (e, selectedRow, index) => {
    setOpportunityIdentification((prevOpp) =>
      prevOpp.map((item, ind) =>
        ind === index
          ? { ...item, category: e.target.value._id }
          : item
      )
    );
    setFilterOpportunityIdentification((prevOpp) =>
      prevOpp.map((item, ind) =>
        ind === index
          ? { ...item, category: e.target.value._id }
          : item
      )
    );
  };

  const displayCategory = (row, index) => {
    const selectedCategory = riskCategory.find(cat => cat._id === row.category);
    return (
      <div key={row._id}>
        <DropdownElement
          onChange={(e) => {
            oppCatChange(e, row, index.rowIndex);
            onOppCategoryChange(e, row, index.rowIndex);
          }}
          id={row._id}
          key={row._id}
          options={(riskCategory != undefined && riskCategory.length > 0) ? riskCategory : []}
          value={selectedCategory || null}
          optionLabel="label"
          placeholder="-- Please select --"
          className={(props.errors.includes('Category') && row.category == '') ? 'error-tab w-150' : 'w-150'}
        />
      </div>
    );
  };

  const displayCategoryName = (row, index) => {
    return <div key={row._id}>{row.opp_CatLabel}</div>;
  };

  const displayDescription = (row, index) => {
    return (
      <div key={index}>
        <label title={row.item_description
        }>
          {row.item_description || "N/A"}
        </label>
      </div>
    );
  };

  const displayPotentialAdvantage = (row, index) => {
    return (
      <div key={index}>
        <label title={row.consequence}>{row.consequence || "N/A"}</label>
      </div>
    );
  };

  const displayActionOwner = (row, index) => {
    return (
      <div key={index}>
        <DropdownElement
          onChange={(e) => {
            oppActionOwnerChange(e, row, index.rowIndex);
          }}
          id={row._id}
          key={row._id}
          options={(propsData.relationshipActionOwner != undefined && propsData.relationshipActionOwner.length > 0) ? propsData.relationshipActionOwner : []}
          value={propsData.relationshipActionOwner.find((obj) => obj._id === row.action_owner)}
          optionLabel="label"
          placeholder="-- Please select --"
          className="w-150"
        />
      </div>
    );
  };

  const riskImpact = [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
  ];

  const computeLikelihoodOppScore = (e, entity) => {
    let riskScore = 0;
    const selLikelihood = e.target.value ?? 0;
    const selImpact = entity.impact ?? 0;

    riskScore = selImpact * selLikelihood;

    const riskColor =
      riskScore >= 1 && riskScore <= 4
        ? "#ff0000"
        : riskScore >= 5 && riskScore <= 14
          ? "#ffa500"
          : riskScore >= 15 && riskScore <= 25
            ? "#008000"
            : "none";

    // Update the opportunity identification list in state
    setOpportunityIdentification((prevOpp) =>
      prevOpp.map((item) =>
        item._id === entity._id
          ? { ...item, opp_score: riskScore, risk_color: riskColor }
          : item
      )
    );
    setFilterOpportunityIdentification((prevOpp) =>
      prevOpp.map((item) =>
        item._id === entity._id
          ? { ...item, opp_score: riskScore, risk_color: riskColor }
          : item
      )
    );

    // Calculate the total opportunity score if needed
    calcTotalOppScore();
  };

  const computeImpactOppScore = (e, entity) => {
    let riskScore = 0;
    const selLikelihood = entity.likelihood ?? 0;
    const selImpact = e.target.value ?? 0;

    riskScore = selImpact * selLikelihood;

    const riskColor =
      riskScore >= 1 && riskScore <= 4
        ? "#ff0000"
        : riskScore >= 5 && riskScore <= 14
          ? "#ffa500"
          : riskScore >= 15 && riskScore <= 25
            ? "#008000"
            : "none";

    // Update the opportunity identification list in state
    setOpportunityIdentification((prevOpp) =>
      prevOpp.map((item) =>
        item._id === entity._id
          ? { ...item, opp_score: riskScore, risk_color: riskColor }
          : item
      )
    );
    setFilterOpportunityIdentification((prevOpp) =>
      prevOpp.map((item) =>
        item._id === entity._id
          ? { ...item, opp_score: riskScore, risk_color: riskColor }
          : item
      )
    );

    // Calculate the total opportunity score if needed
    calcTotalOppScore();
  };

  useEffect(() => { }, [riskGroups]);

  const computeImpactRiskScore = (e, entity, group, index) => {
    let riskScore = 0;
    const selLikelihood = entity.likelihood ?? 0;
    const selImpact = e.target.value ?? 0;

    riskScore = selImpact * selLikelihood;

    const riskColor =
      riskScore >= 1 && riskScore <= 4
        ? "#008000"
        : riskScore >= 5 && riskScore <= 14
          ? "#ffa500"
          : riskScore >= 15 && riskScore <= 25
            ? "#ff0000"
            : "none";

    // Update the opportunity identification list in state

    setRiskGroups((prevGroups) => ({
      ...prevGroups,
      [group]: prevGroups[group].map((item, ind) =>
        ind === index
          ? { ...item, risk_score: riskScore, risk_color: riskColor }
          : item
      ),
    }));
    setFilteredRiskGroups((prevGroups) => ({
      ...prevGroups,
      [group]: prevGroups[group].map((item, ind) =>
        ind === index
          ? { ...item, risk_score: riskScore, risk_color: riskColor }
          : item
      ),
    }));

    calcTotalRiskScore();
  };

  const computeLikelihoodRiskScore = (e, entity, group, index) => {
    let riskScore = 0;
    const selLikelihood = e.target.value ?? 0;
    const selImpact = entity.impact ?? 0;

    riskScore = selImpact * selLikelihood;

    const riskColor =
      riskScore >= 1 && riskScore <= 4
        ? "#008000"
        : riskScore >= 5 && riskScore <= 14
          ? "#ffa500"
          : riskScore >= 15 && riskScore <= 25
            ? "#ff0000"
            : "none";

    // Update the opportunity identification list in state

    setRiskGroups((prevGroups) => ({
      ...prevGroups,
      [group]: prevGroups[group].map((item, ind) =>
        ind === index
          ? { ...item, risk_score: riskScore, risk_color: riskColor }
          : item
      ),
    }));
    setFilteredRiskGroups((prevGroups) => ({
      ...prevGroups,
      [group]: prevGroups[group].map((item, ind) =>
        ind === index
          ? { ...item, risk_score: riskScore, risk_color: riskColor }
          : item
      ),
    }));

    // Calculate the total opportunity score if needed
    calcTotalRiskScore();
  };

  useEffect(() => {
    calcTotalRiskScore();
  }, [riskGroups])

  const onLikelihoodChange = (e, selectedRow, index) => {
    let riskScore = 0;
    const selLikelihood = e.target.value ?? 0;
    const selImpact = selectedRow.impact ?? 0;

    riskScore = selImpact * selLikelihood;

    const riskColor =
      riskScore >= 1 && riskScore <= 4
        ? "#ff0000"
        : riskScore >= 5 && riskScore <= 14
          ? "#ffa500"
          : riskScore >= 15 && riskScore <= 25
            ? "#008000"
            : "none";

    setOpportunityIdentification((prevOpp) =>
      prevOpp.map((item, ind) =>
        ind === index
          ? { ...item, likelihood: e.target.value, opp_score: riskScore, risk_color: riskColor }
          : item
      )
    );
    setFilterOpportunityIdentification((prevOpp) =>
      prevOpp.map((item, ind) =>
        ind === index
          ? { ...item, likelihood: e.target.value, opp_score: riskScore, risk_color: riskColor }
          : item
      )
    );
    calcTotalOppScore();
  };

  const onLikelihoodChange1 = (e, selectedRow, group, index) => {
    setRiskGroups((prevGroups) => ({
      ...prevGroups,
      [group]: prevGroups[group].map((item, ind) =>
        ind === index
          ? { ...item, likelihood: e.target.value }
          : item
      ),
    }));
    setFilteredRiskGroups((prevGroups) => ({
      ...prevGroups,
      [group]: prevGroups[group].map((item, ind) =>
        ind === index
          ? { ...item, likelihood: e.target.value }
          : item
      ),
    }));
    calcTotalRiskScore();
  };

  const onImpactChange = (e, selectedRow, index) => {
    let riskScore = 0;
    const selLikelihood = selectedRow.likelihood ?? 0;
    const selImpact = e.target.value ?? 0;

    riskScore = selImpact * selLikelihood;

    const riskColor =
      riskScore >= 1 && riskScore <= 4
        ? "#ff0000"
        : riskScore >= 5 && riskScore <= 14
          ? "#ffa500"
          : riskScore >= 15 && riskScore <= 25
            ? "#008000"
            : "none";

    setOpportunityIdentification((prevOpp) =>
      prevOpp.map((item, ind) =>
        ind === index
          ? { ...item, impact: e.target.value, opp_score: riskScore, risk_color: riskColor }
          : item
      )
    );
    setFilterOpportunityIdentification((prevOpp) =>
      prevOpp.map((item, ind) =>
        ind === index
          ? { ...item, impact: e.target.value, opp_score: riskScore, risk_color: riskColor }
          : item
      )
    );
    calcTotalOppScore();
  };

  const onImpactChange1 = (e, selectedRow, group, index) => {
    setRiskGroups((prevGroups) => ({
      ...prevGroups,
      [group]: prevGroups[group].map((item, ind) =>
        ind === index
          ? { ...item, impact: e.target.value }
          : item
      ),
    }));
    setFilteredRiskGroups((prevGroups) => ({
      ...prevGroups,
      [group]: prevGroups[group].map((item, ind) =>
        ind === index
          ? { ...item, impact: e.target.value }
          : item
      ),
    }));
    calcTotalRiskScore();
  };

  const onOwnerChange = (e, selectedRow, index) => {
    setOpportunityIdentification((prevOpp) =>
      prevOpp.map((item, ind) =>
        ind === index
          ? { ...item, opp_owner: e.target.value._id }
          : item
      )
    );
    setFilterOpportunityIdentification((prevOpp) =>
      prevOpp.map((item, ind) =>
        ind === index
          ? { ...item, opp_owner: e.target.value._id }
          : item
      )
    );
  };

  const onOwnerChange1 = (e, selectedRow, group, index) => {
    setRiskGroups((prevGroups) => ({
      ...prevGroups,
      [group]: prevGroups[group].map((item, ind) =>
        ind === index
          ? { ...item, risk_owner: e.target.value._id }
          : item
      ),
    }));
    setFilteredRiskGroups((prevGroups) => ({
      ...prevGroups,
      [group]: prevGroups[group].map((item, ind) =>
        ind === index
          ? { ...item, risk_owner: e.target.value._id }
          : item
      ),
    }));
  };

  const displayLikelihood = (row, index) => {
    return (
      <div key={index}>
        <DropdownElement
          onChange={(e) => {
            onLikelihoodChange(e, row, index.rowIndex);
            // computeLikelihoodOppScore(e, row);
          }}
          id={row._id}
          options={(riskImpact != undefined && riskImpact.length > 0) ? riskImpact : []}
          value={row.likelihood}
          optionLabel="label"
          placeholder="-- Please select --"
          className="w-150"
        />
      </div>
    );
  };

  const displayActionByDate = (row, index) => {
    return (
      <div key={index}>
        <CalendarElement
          id="cost_base_date"
          className="ml-10"
          defaultValue={parseDateString(row.action_bydate)}
          value={parseDateString(row.action_bydate)}
          onChange={(e) => {
            handleOppCalenderDetailInputChange(e, row, index.rowIndex);
          }}
          maxLength="50"
          placeholder="Date"
          autocomplete="off"
        />
      </div>
    );
  };

  const displayImpact = (row, index) => {
    return (
      <div key={index}>
        <DropdownElement
          onChange={(e) => {
            onImpactChange(e, row, index.rowIndex);
            // computeImpactOppScore(e, row);
          }}
          id={row._id}
          options={(riskImpact != undefined && riskImpact.length > 0) ? riskImpact : []}
          value={row.impact}
          optionLabel="label"
          placeholder="-- Please select --"
          className="w-150"
        />
      </div>
    );
  };

  const displayActionTaken = (row, index) => {
    return (
      <div key={index}>
        <div className="flex justify-content-center p-auto pt-2" key={index}>
          <label title={row.action_taken}>{row.action_taken || "N/A"}</label>
        </div>
      </div>
    );
  };

  const displayScore = (row, index) => {
    return (
      <div
        style={{ background: `${row.risk_color}` }}
        className="flex justify-content-center p-auto pt-2"
        key={index}
      >
        <label title={row.opp_score} className="font-color-white">{row.opp_score || "N/A"}</label>
      </div>
    );
  };

  const displayProgrammeImpact = (row, index) => {
    return (
      <div className="flex justify-content-center p-auto pt-2" key={index}>
        <label title={row.programme_impact}>
          {row.programme_impact || "N/A"}
        </label>
      </div>
    );
  };

  const displayPlannedAction = (row, index) => {
    return (
      <div className="flex justify-content-center p-auto pt-2" key={index}>
        <label title={row.planned_action}>{row.planned_action || "N/A"}</label>
      </div>
    );
  };

  const handlePotientialCostChange = (e, selectedRow, index) => {
    setOpportunityIdentification((prevOpp) =>
      prevOpp.map((item, ind) =>
        ind === index
          ? { ...item, potential_saving: e.target.value }
          : item
      )
    );
    setFilterOpportunityIdentification((prevOpp) =>
      prevOpp.map((item, ind) =>
        ind === index
          ? { ...item, potential_saving: e.target.value }
          : item
      )
    );
  };

  const handleActualCostChange = (e, selectedRow, index) => {
    setOpportunityIdentification((prevOpp) =>
      prevOpp.map((item, ind) =>
        ind === index
          ? { ...item, actual_saving: e.target.value }
          : item
      )
    );
    setFilterOpportunityIdentification((prevOpp) =>
      prevOpp.map((item, ind) =>
        ind === index
          ? { ...item, actual_saving: e.target.value }
          : item
      )
    );
  };

  const displayPotentialCost = (row, index) => {
    return (
      <div className="flex justify-content-center p-auto pt-2" key={index}>
        <InputTextElementElement
          className="dropdown-field-handle"
          defaultValue={row.potential_saving}
          name="potential_saving"
          placeholder="Amount"
          onChange={(e) => handlePotientialCostChange(e, row, index.rowIndex)}
        />
      </div>
    );
  };

  const displayOwner = (row, index) => {
    return (
      <div key={index}>
        <DropdownElement
          onChange={(e) => onOwnerChange(e, row, index.rowIndex)}
          id={row._id}
          options={(propsData.relationshipOwner != undefined && propsData.relationshipOwner.length > 0) ? propsData.relationshipOwner : []}
          value={propsData.relationshipOwner.find((obj) => obj._id === row.opp_owner)}
          optionLabel="label"
          placeholder="-- Please select --"
          className="w-150"
        />
      </div>
    );
  };

  const displayIsCompleted = (row, index) => {
    return (
      <div key={index}>
        <CheckboxElement
          checked={row.isCompleted}
          onChangeCheck={(e) => opportunityCompleted(row, e, index.rowIndex)}
        ></CheckboxElement>
      </div>
    );
  };

  const displayActualCost = (row, index) => {
    return (
      <div key={index}>
        <InputTextElementElement
          className="dropdown-field-handle"
          value={row.actual_saving}
          name="actual_saving"
          placeholder="Amount"
          onChange={(e) => handleActualCostChange(e, row, index.rowIndex)}
        />
      </div>
    );
  };

  const handleOpenRiskIdentification = (row, group) => {
    if (!_.isEmpty(row.risk_category)) {
      const riskCat = _.filter(propsData.riskCategory, {
        _id: row.risk_category,
      });
      if (!_.isEmpty(riskCat)) {
        var tmpFactor = group + "##" + riskCat[0].label;
        const tmpOpts = _.filter(
          _.find(propsData.data, { display_name: tmpFactor }).option_choice,
          { status: "active" }
        );
        const factorName = _.filter(tmpOpts, {
          _id: row.risk_factor,
        });
        row["factor"] = factorName[0].label

      }
    }
    setSelectedRiskToView(row);
    setSelectedGroupToView(group);
    setOpenRiskIdentification(true);
  };

  const handleOpenOppIdentification = (row) => {
    setSelectedToView(row);
    setOpenOppIdentification(true);
  };

  const handleOpenOppManagement = (row, group) => {
    setSelectedOppManagementToView(row);
    setSelectedGroupToView(group);

    setOpenOppManagement(true);
  };

  const handleCloseOppManagement = () => {
    setSelectedOppManagementToView(null);
    setSelectedGroupToView("");
    setOpenOppManagement(false);
  };

  const renderFooterCloseOpp = () => {
    return (
      <div className="cancel-footer">
        <div className="align-center justify-end pb-0">
          <ButtonElement label="Cancel" className="cancel-new-button" onClick={() => handleCloseOppManagement()} />
        </div>
      </div>
    );
  }

  const closeOpenRiskIdentification = () => {
    setSelectedRiskToView([]);
    setSelectedGroupToView("");
    setOpenRiskIdentification(false);
  };

  const renderFooterRiskMgmt = () => {
    return (
      <div className="cancel-footer">
        <div className="align-center justify-end pb-0">
          <ButtonElement label="Cancel" className="cancel-new-button" onClick={() => closeOpenRiskIdentification()} />
        </div>
      </div>
    );
  }

  const closeOpenOppIdentification = () => {
    setSelectedToView([]);
    setOpenOppIdentification(false);
  };

  const handleEditRiskIdentification = (row, group, index) => {
    if (!_.isEmpty(row.risk_category)) {
      const riskCat = _.filter(propsData.riskCategory, {
        _id: row.risk_category,
      });
      if (!_.isEmpty(riskCat)) {
        var tmpFactor = group + "##" + riskCat[0].label;
        const tmpOpts = _.filter(
          _.find(propsData.data, { display_name: tmpFactor }).option_choice,
          { status: "active" }
        );
        const factorName = _.filter(tmpOpts, {
          _id: row.risk_factor,
        });
        row["factor"] = factorName[0]?.label

      }
    }
    setSelectedRiskToView(row);
    setSelectedGroupToView(group);
    setSelectedRiskGroupIndex(index)
    setOpenEditRiskIdentification(true);
  };

  const closeEditRiskIdentification = () => {
    setLoading(false)
    setSelectedRiskToView([]);
    setSelectedGroupToView("");
    setOpenEditRiskIdentification(false);
  };

  const handleEditOppIdentification = (row, index) => {
    setSelectedToView(row);
    setOppIdentifyIndex(index)
    setOpenEditOppIdentification(true);
  };

  const handleEditOppManagement = (row, index) => {
    setSelectedToView1(row);
    setOppManageIndex(index)
    setOpenEditOppManagement(true);
  };

  const closeEditOppManagement = () => {
    setLoading(false)
    setSelectedToView1([]);
    setOpenEditOppManagement(false);
  };

  const closeEditOppIdentification = () => {
    // setSelectedToView([]);
    setLoading(false)
    setOpenEditOppIdentification(false);
  };

  const renderFooterEditOpp = () => {
    return (
      <div className="cancel-footer">
        <div className="align-center justify-end pb-0">
          <ButtonElement label="Cancel" className="cancel-new-button" onClick={() => closeEditOppIdentification()} />
          <ButtonElement type="submit" label="Save" className="save-button" onClick={() => addOppIdentificationData()} />
        </div>
      </div>
    );
  }

  const renderFooterEditManagement = () => {
    return (
      <div className="cancel-footer">
        <div className="align-center justify-end pb-0">
          <ButtonElement label="Cancel" className="cancel-new-button" onClick={() => closeEditOppManagement()} />
          <ButtonElement type="submit" label="Save" className="save-button" onClick={() => addOppManagementData()} />
        </div>
      </div>
    );
  }

  const renderFooterOpenOpp = () => {
    return (
      <div className="cancel-footer">
        <div className="align-center justify-end pb-0">
          <ButtonElement label="Cancel" className="cancel-new-button" onClick={() => closeOpenOppIdentification()} />
        </div>
      </div>
    );
  }

  const displayActionButtons = (row, index) => {
    return (
      <div key={index} className="flex gap-1">
        <InputIcon
          className="pi pi-eye ml-0"
          key={row._id}
          type="button"
          onClick={() => handleOpenOppIdentification(row, index.rowIndex)}
        />
        <InputIcon
          className="pi pi-pencil ml-10"
          type="button"
          onClick={() => handleEditOppIdentification(row, index.rowIndex)}
        />
      </div>
    );
  };

  const displayOppManagementActionButtons = (row, index) => {
    return (
      <div key={index} className="flex gap-1">
        <InputIcon
          className="pi pi-eye ml-0"
          key={row._id}
          type="button"
          onClick={() => handleOpenOppManagement(row, "xyz")}
        />
        <InputIcon
          className="pi pi-pencil ml-10"
          type="button"
          onClick={() => handleEditOppManagement(row, index.rowIndex)}
        />
      </div>
    );
  };

  const opportunityManagementColumns = [
    {
      field: "opp_CatLabel",
      header: `${propsData.oppManagementHeaders?.find(
        (header) => header.header_name === "Category"
      )?.display_name
        }`,
      body: displayCategoryName,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "item_description",
      header: `${propsData.oppManagementHeaders?.find(
        (header) => header.header_name === "Description"
      )?.display_name
        }`,
      body: displayDescription,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "action_owner",
      header: `${propsData.oppManagementHeaders?.find(
        (header) => header.header_name === "Action Owner"
      )?.display_name
        }`,
      body: displayActionOwner,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "action_bydate",
      header: `${propsData.oppManagementHeaders?.find(
        (header) => header.header_name === "Action By Date"
      )?.display_name
        }`,
      body: displayActionByDate,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "action_taken",
      header: `${propsData.oppManagementHeaders?.find(
        (header) => header.header_name === "Action Taken"
      )?.display_name
        }`,
      body: displayActionTaken,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "programme_impact",
      header: `${propsData.oppManagementHeaders?.find(
        (header) => header.header_name === "Programme Impact"
      )?.display_name
        }`,
      body: displayProgrammeImpact,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "potential_saving",
      header: `${propsData.oppManagementHeaders?.find(
        (header) => header.header_name === "Potential Saving"
      )?.display_name
        }`,
      body: displayPotentialCost,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "actual_saving",
      header: `${propsData.oppManagementHeaders?.find(
        (header) => header.header_name === "Actual Saving"
      )?.display_name
        }`,
      body: displayActualCost,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "isCompleted",
      header: `${propsData.oppManagementHeaders?.find(
        (header) => header.header_name === "Completed"
      )?.display_name
        }`,
      body: displayIsCompleted,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "status",
      header: "",
      body: displayOppManagementActionButtons,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
  ];

  const columns = [
    {
      field: "category",
      header: `${propsData.oppIdentificationHeaders?.find(
        (header) => header.header_name === "Category"
      )?.display_name
        }`,
      body: displayCategory,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "item_description",
      header: `${propsData.oppIdentificationHeaders?.find(
        (header) => header.header_name === "Description"
      )?.display_name
        }`,
      body: displayDescription,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "consequence",
      header: `${propsData.oppIdentificationHeaders?.find(
        (header) => header.header_name === "Potential Advantage"
      )?.display_name
        }`,
      body: displayPotentialAdvantage,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "likelihood",
      header: `${propsData.oppIdentificationHeaders?.find(
        (header) => header.header_name === "Likelihood"
      )?.display_name
        }`,
      body: displayLikelihood,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "impact",
      header: `${propsData.oppIdentificationHeaders?.find(
        (header) => header.header_name === "Impact"
      )?.display_name
        }`,
      body: displayImpact,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "risk_color",
      header: `${propsData.oppIdentificationHeaders?.find(
        (header) => header.header_name === "Score"
      )?.display_name
        }`,
      body: displayScore,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "planned_action",
      header: `${propsData.oppIdentificationHeaders?.find(
        (header) => header.header_name === "Planned Action"
      )?.display_name
        }`,
      body: displayPlannedAction,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "opp_owner",
      header: `${propsData.oppIdentificationHeaders?.find(
        (header) => header.header_name === "Owner"
      )?.display_name
        }`,
      body: displayOwner,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "status",
      header: "",
      body: displayActionButtons,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
  ];

  const riskManagementColumns = [
    {
      field: "label",
      header: `${propsData.oppRiskManagementHeaders?.find(
        (header) => header.header_name === "Category"
      )?.display_name
        }`,
      // body: labelEditor,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "score",
      header: `${propsData.oppRiskManagementHeaders?.find(
        (header) => header.header_name === "Description"
      )?.display_name
        }`,
      //   body: scoreEditor,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "status",
      header: `${propsData.oppRiskManagementHeaders?.find(
        (header) => header.header_name === "Action Owner"
      )?.display_name
        }`,
      //   body: statusEditor,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "status",
      header: `${propsData.oppRiskManagementHeaders?.find(
        (header) => header.header_name === "Action By Date"
      )?.display_name
        }`,
      //   body: statusEditor,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "status",
      header: `${propsData.oppRiskManagementHeaders?.find(
        (header) => header.header_name === "Action Taken"
      )?.display_name
        }`,
      //   body: statusEditor,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "status",
      header: `${propsData.oppRiskManagementHeaders?.find(
        (header) => header.header_name === "Programme Impact"
      )?.display_name
        }`,
      //   body: statusEditor,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "status",
      header: `${propsData.oppRiskManagementHeaders?.find(
        (header) => header.header_name === "Potential Cost"
      )?.display_name
        }`,
      //   body: statusEditor,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "status",
      header: `${propsData.oppRiskManagementHeaders?.find(
        (header) => header.header_name === "Actual Cost"
      )?.display_name
        }`,
      //   body: statusEditor,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "status",
      header: `${propsData.oppRiskManagementHeaders?.find(
        (header) => header.header_name === "Completed"
      )?.display_name
        }`,
      //   body: statusEditor,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
  ];

  const columns1 = [
    {
      field: "label",
      header: `${propsData.oppRiskIdentificationHeaders?.find(
        (header) => header.header_name === "Category"
      )?.display_name
        }`,
      // body: labelEditor,
      headerClassName: "header-datatable",
      className: "row-datatable"
    },
    {
      field: "score",
      header: `${propsData.oppRiskIdentificationHeaders?.find(
        (header) => header.header_name === "Description"
      )?.display_name
        }`,
      //   body: scoreEditor,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "status",
      header: `${propsData.oppRiskIdentificationHeaders?.find(
        (header) => header.header_name === "Factors"
      )?.display_name
        }`,
      //   body: statusEditor,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "status",
      header: `${propsData.oppRiskIdentificationHeaders?.find(
        (header) => header.header_name === "Consequence"
      )?.display_name
        }`,
      //   body: statusEditor,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "status",
      header: `${propsData.oppRiskIdentificationHeaders?.find(
        (header) => header.header_name === "Likelihood"
      )?.display_name
        }`,
      //   body: statusEditor,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "status",
      header: `${propsData.oppRiskIdentificationHeaders?.find(
        (header) => header.header_name === "Impact"
      )?.display_name
        }`,
      //   body: statusEditor,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "status",
      header: `${propsData.oppRiskIdentificationHeaders?.find(
        (header) => header.header_name === "Score"
      )?.display_name
        }`,
      //   body: statusEditor,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "status",
      header: `${propsData.oppRiskIdentificationHeaders?.find(
        (header) => header.header_name === "Planned Action"
      )?.display_name
        }`,
      //   body: statusEditor,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    {
      field: "status",
      header: `${propsData.oppRiskIdentificationHeaders?.find(
        (header) => header.header_name === "Owner"
      )?.display_name
        }`,
      //   body: statusEditor,
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
  ];

  const parseDateString = (dateString) => {
    if (dateString) {
      const [day, month, year] = dateString.split("-")?.map(Number);
      return new Date(year, month - 1, day); // Month is 0-indexed in JavaScript Date
    }
  };

  const formatDate = (input) => {
    const date = input instanceof Date ? input : new Date(input);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleOppCalenderDetailInputChange = (e, selectedRow, index) => {
    setOpportunityIdentification((prevOpp) =>
      prevOpp.map((item, ind) =>
        ind === index
          ? { ...item, action_bydate: formatDate(e.target.value) }
          : item
      )
    );
    setFilterOpportunityIdentification((prevOpp) =>
      prevOpp.map((item, ind) =>
        ind === index
          ? { ...item, action_bydate: formatDate(e.target.value) }
          : item
      )
    );
  };

  const getActionOwners = () => {
    const newActionOwners = [];
    const newInternBidTeamUsers = [];

    if (propsData.opportunityData?.ie_bid_team) {
      const internalBidTeam =
        propsData.opportunityData.ie_bid_team.internal_bid_team;
      const externalBidTeam =
        propsData.opportunityData.ie_bid_team.external_bid_team;

      if (internalBidTeam) {
        internalBidTeam.forEach((member) => {
          const owner = {
            user_id: member.user_id,
            team_member: member.team_member,
            email_id: member.email,
          };
          newActionOwners.push(owner);
          newInternBidTeamUsers.push(owner);
        });
      }

      if (externalBidTeam) {
        externalBidTeam.forEach((member) => {
          newActionOwners.push({
            user_id: member._id,
            team_member: member.external_organisation,
            email_id: member.email,
          });
        });
      }

      // Update state with new values
      setActionOwners(newActionOwners);
      setInternBidTeamUsers(newInternBidTeamUsers);

      // Set filters for multi-selects
      const updatedActionOwnersFilter = newActionOwners.map((ao) => ({
        _id: ao.user_id,
        label: ao.team_member,
        email_id: ao.email_id,
      }));

      const updatedInternBidUserFilter = newInternBidTeamUsers.map((ao) => ({
        _id: ao.user_id,
        label: ao.team_member,
        email_id: ao.email_id,
      }));

      setActionOwnersFilter(updatedActionOwnersFilter);
      setInternBidUserFilter(updatedInternBidUserFilter);
    }
  };

  useEffect(() => {
    getActionOwners();
  }, [propsData.opportunityData]);

  // calculate risk score
  const calcTotalRiskScore = () => {
    let tmpSum = 0;
    const updatedRiskScoreByCat = {};
    const updatedRiskCount = { Low: 0, Medium: 0, High: 0 };

    propsData.riskCategory.forEach((category) => {
      updatedRiskScoreByCat[category.label] = 0;
    });
    const riskDetails1 = globalOpportunityData?.risk_identification?.slice(0);
    riskDetails1?.forEach((riskDetail) => {
      const risk = propsData.riskType?.find(
        (r) => r._id === riskDetail.risk_type
      );
      if (risk) {
        riskDetail.risk_details.forEach((detail) => {
          if (detail.risk_category) {
            const riskCat = propsData.riskCategory.find(
              (cat) => cat._id === detail.risk_category
            );

            if (riskCat) {
              const riskScore = detail.risk_score;

              if (riskScore >= 1 && riskScore <= 4) {
                updatedRiskCount.Low += 1;
              } else if (riskScore >= 5 && riskScore <= 14) {
                updatedRiskCount.Medium += 1;
              } else if (riskScore >= 15 && riskScore <= 25) {
                updatedRiskCount.High += 1;
              }

              updatedRiskScoreByCat[riskCat.label] += riskScore;
              tmpSum += riskScore;
            }
          }
        });
      }
    });
    setRiskScoreByCat(updatedRiskScoreByCat);
    setRiskCount(updatedRiskCount);
    setTotalRiskScoreByCat((prevState) => ({
      ...prevState,
      riskSum: tmpSum,
    }));
  };

  // calculate opp score
  const calcTotalOppScore = () => {
    let tmpSum = 0;
    let tmpOppScoreByCat = {};
    let tmpOppCount = { Low: 0, Medium: 0, High: 0 };
    propsData.riskCategory.forEach((category) => {
      tmpOppScoreByCat[category.label] = 0;
    });

    globalOpportunityData.opportunity_identification?.forEach(
      (identification) => {
        let risk = propsData.riskCategory.find(
          (category) => category._id === identification.category
        );
        if (risk) {
          let riskScore = identification.opp_score;
          let currentScore = tmpOppScoreByCat[risk.label];

          if (riskScore >= 1 && riskScore <= 4) {
            tmpOppCount.Low += 1;
          } else if (riskScore >= 5 && riskScore <= 14) {
            tmpOppCount.Medium += 1;
          } else if (riskScore >= 15 && riskScore <= 25) {
            tmpOppCount.High += 1;
          }

          tmpOppScoreByCat[risk.label] =
            Number(currentScore) + Number(riskScore);
          tmpSum += Number(riskScore);
        }
      }
    );

    setOppScoreByCat(tmpOppScoreByCat);
    setOppCount(tmpOppCount);
    setTotalRiskScoreByCat((prevState) => ({
      ...prevState,
      riskOppSum: tmpSum,
    }));

    setOppScoreLength(Object.keys(tmpOppScoreByCat).length);
  };

  useEffect(() => {
    calcTotalOppScore();
  }, [propsData.opportunityData, propsData.riskCategory, opportunityIdentification]);

  useEffect(() => {
    calcTotalRiskScore();
  }, [propsData.opportunityData, propsData.riskCategory]);

  const getCustomerData = async () => {
    try {
      if (props?.customerId) {
        setLoading(true);
        // Fetch customer data
        const customer = await getCustomer(props?.customerId);
        setCustomerTooltipData(customer.data?.tooltips?.pipeline?.risks);
      } else {
        toastRef.current.showToast({
          type: "error",
          message: "Customer ID is missing. Please provide a valid customer ID.",
        });
      }
    } catch (error) {
      // Handle any errors that occur during the customer data fetch
      toastRef.current.showToast({
        type: "error",
        message: "Failed to fetch customer data. Please try again or contact Admin.",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCostPlanChange = (value) => {
    setGlobalOpportunityData((prevData) => ({
      ...prevData,
      risk_summary: {
        ...prevData.risk_summary,
        cost_plan_provided: value,
      },
    }));
  };

  const handleCostBaseDateChange = (e) => {
    setGlobalOpportunityData((prevData) => ({
      ...prevData,
      risk_summary: {
        ...prevData.risk_summary,
        cost_base_date: formatDate(e.target.value),
      },
    }));
  };

  const handleMultiSelect = (e) => {
    const selectedData = e.target.value;

    const newRiskGroups = selectedData.reduce((acc, item) => {
      if (!acc[item.label]) {
        acc[item.label] = [
          {
            notified: false,
            isCompleted: false,
            // _id: generateRandomID(),
            risk_score: 0,
            risk_category: "",
            likelihood: "",
            impact: "",
            risk_factor: "",
            risk_owner: "",
            risk_description: "N/A",
            planned_action: "N/A",
            consequence: "N/A",
            risk_color: "none",
            factor_opt: [],
          },
        ];
      }
      return acc;
    }, {});

    setRiskGroups((prevState) => {
      const updatedState = { ...prevState };
      Object.keys(newRiskGroups).forEach((key) => {
        if (!updatedState[key]) {
          updatedState[key] = newRiskGroups[key];
        }
      });

      return updatedState;
    });

    setFilteredRiskGroups((prevState) => {
      const updatedState = { ...prevState };
      Object.keys(newRiskGroups).forEach((key) => {
        if (!updatedState[key]) {
          updatedState[key] = newRiskGroups[key];
        }
      });

      return updatedState;
    });

    setRiskTypeData(selectedData);
  };

  const handleplanningGrantedRadioChange = (value) => {
    setGlobalOpportunityData((prevData) => ({
      ...prevData,
      risk_summary: {
        ...prevData.risk_summary,
        planning_granted: value,
      },
    }));
  };

  const handlePlanningReferenceNumberChange = (e) => {
    setGlobalOpportunityData((prevData) => ({
      ...prevData,
      risk_summary: {
        ...prevData.risk_summary,
        planning_reference_number: e.target.value,
      },
    }));
  };

  const handlePlanningReferenceLinkChange = (e) => {
    setGlobalOpportunityData((prevData) => ({
      ...prevData,
      risk_summary: {
        ...prevData.risk_summary,
        planning_reference_link: e.target.value,
      },
    }));
  };

  const handleInsuranceCoverRadioChange = (value) => {
    setGlobalOpportunityData((prevData) => ({
      ...prevData,
      additional_considerations: {
        ...prevData.additional_considerations,
        insurance_cover: value,
      },
    }));
  };

  const resetButton1 = () => {
    setSelectedStatus1([]);
    setSelectedOwnerResp1([]);
    setShowDropdown1(false)
  };

  const resetButton = () => {
    setSelectedStatus([]);
    setSelectedOwnerResp([]);
    setShowDropdown(false)
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const toggleDropdown1 = () => {
    setShowDropdown1(!showDropdown1);
  };

  const handleStatusSelection = (event) => {
    if (event.length > 0) {
      setSelectedStatus(event);
    } else {
      setSelectedStatus([]);
    }
  };

  const handleStatusSelection1 = (event) => {
    if (event.length > 0) {
      setSelectedStatus1(event);
    } else {
      setSelectedStatus1([]);
    }
  };

  const handleSelection = (event) => {
    if (event.length > 0) {
      setSelectedOwnerResp(event);
    } else {
      setSelectedOwnerResp([]);
    }
  };

  //   Filter for Opportunity Identification
  useEffect(() => {
    if (selectedOwnerResp.length > 0 || selectedStatus.length > 0) {
      const filteredRisks = filterOpportunityIdentification.filter((risk) =>
        selectedOwnerResp.some(
          (owner) =>
            owner._id === risk.risk_owner || owner._id === risk.action_owner
        )
      );
      setOpportunityIdentification(filteredRisks);
      if (selectedStatus.length > 0) {
        const statusFilteredRisks = opportunityIdentification.filter((risk) =>
          selectedStatus.some((status) => status === risk.isCompleted)
        );
        setOpportunityIdentification(statusFilteredRisks);
      }
    } else {
      setOpportunityIdentification(filterOpportunityIdentification);
    }
  }, [selectedOwnerResp, selectedStatus, filterOpportunityIdentification]);

  useEffect(() => {
    let filteredGroups = { ...filteredRiskGroups };

    // Filter by selectedOwnerResp1
    if (selectedOwnerResp1.length > 0) {
      filteredGroups = Object.keys(filteredGroups).reduce((acc, key) => {
        const filteredRisks = filteredGroups[key].filter((risk) =>
          selectedOwnerResp1.some(
            (owner) =>
              owner._id === risk.risk_owner || owner._id === risk.action_owner
          )
        );

        if (filteredRisks.length > 0) {
          acc[key] = filteredRisks;
        }

        return acc;
      }, {});
    }

    // Filter by selectedStatus1
    if (selectedStatus1.length > 0) {
      filteredGroups = Object.keys(filteredGroups).reduce((acc, key) => {
        const filteredRisks = filteredGroups[key].filter((risk) =>
          selectedStatus1.includes(risk.isCompleted)
        );

        if (filteredRisks.length > 0) {
          acc[key] = filteredRisks;
        }

        return acc;
      }, {});
    }

    // Set the filtered risk groups
    setRiskGroups(filteredGroups);
    setLoading(false);
  }, [selectedOwnerResp1, selectedStatus1]);

  const handleSelection1 = (event) => {
    setLoading(true)
    if (event.length > 0) {
      setSelectedOwnerResp1(event);
    } else {
      setSelectedOwnerResp1([]);
    }
  };

  const addNewOppIdentify = () => {
    const newOppIdentification = {
      notified: false,
      isCompleted: false,
      id: generateRandomID(),
      opp_score: 0,
      category: "",
      likelihood: "",
      impact: "",
      opp_owner: "",
      item_description: "",
      planned_action: "",
      consequence: "",
      risk_color: "none",
      opp_CatLabel: "",
    };
    setOpportunityIdentification((prevOpp) => [
      ...prevOpp,
      newOppIdentification,
    ]);
    setFilterOpportunityIdentification((prevOpp) => [
      ...prevOpp,
      newOppIdentification,
    ]);
  };

  const deleteOppIdentification = () => {
    if (teamEditPrivilege) {
      setOpportunityIdentification((prevData) =>
        prevData.filter(
          (item) =>
            !checkedIdentifications?.some((selected) => selected.id ? selected.id === item.id : selected._id === item._id)
        )
      );
      setFilterOpportunityIdentification((prevData) =>
        prevData.filter(
          (item) =>
            !checkedIdentifications?.some((selected) => selected.id ? selected.id === item.id : selected._id === item._id)
        )
      );
    } else {
      toastRef.current.showToast({
        type: "error",
        message: "Permission Denied",
      });
    }
  };

  const rowClick = (row) => {
    setCheckedIdentifications(row);
  };
  function generateRandomID() {
    const hexChars = "0123456789abcdef";
    let result = "";
    for (let i = 0; i < 24; i++) {
      result += hexChars.charAt(Math.floor(Math.random() * hexChars.length));
    }
    return result;
  }

  useEffect(() => {
    if (riskGroups != null || riskGroups != undefined) {
      const outputData = Object.keys(riskGroups).map((riskTypeLabel) => {
        const riskTypeId = propsData.riskType.find(
          (type) => type.label === riskTypeLabel
        );
        const checking = propsData.opportunityData.risk_identification
          .slice(0)
          .find((type) => type.risk_typeLabel === riskTypeLabel);
        if (checking) {
          return {
            _id: checking._id,
            risk_type: riskTypeId._id,
            risk_typeLabel: riskTypeLabel,
            risk_details: riskGroups[riskTypeLabel],
          };
        } else {
          return {
            // _id: generateRandomID,
            risk_type: riskTypeId._id,
            risk_typeLabel: riskTypeLabel,
            risk_details: riskGroups[riskTypeLabel],
          };
        }
      });
      setGlobalOpportunityData((prevData) => ({
        ...prevData,
        risk_identification: outputData,
      }));
    }
  }, [riskGroups]);

  const catChange = (e, selectedRow, group) => {
    if (!_.isEmpty(selectedRow.risk_category)) {
      const riskCat = _.filter(propsData.riskCategory, {
        _id: e.target.value._id,
      });
      if (!_.isEmpty(riskCat)) {
        var tmpFactor = group + "##" + riskCat[0].label;
        const tmpOpts = _.filter(
          _.find(propsData.data, { display_name: tmpFactor }).option_choice,
          { status: "active" }
        );
        setRiskGroups((prevGroups) => ({
          ...prevGroups,
          [group]: prevGroups[group].map((item) =>
            item._id === selectedRow._id
              ? { ...item, factor_opt: tmpOpts }
              : item
          ),
        }));
      }
    }

    calcTotalRiskScore();
  };

  const [selectedGroup, setSelectedGroup] = useState("");
  const handleAddButtonClick = () => {
    if (selectedGroup) {
      setRiskGroups((prevState) => {
        const newObject = {
          notified: false,
          isCompleted: false,
          // _id: generateRandomID(),
          risk_score: 0,
          risk_category: "",
          likelihood: "",
          impact: "",
          risk_factor: "",
          risk_owner: "",
          risk_description: "N/A",
          planned_action: "N/A",
          consequence: "N/A",
          risk_color: "none",
          factor_opt: [],
        };

        const updatedGroup = Array.isArray(prevState[selectedGroup])
          ? [...prevState[selectedGroup], newObject]
          : [newObject];

        return {
          ...prevState,
          [selectedGroup]: updatedGroup,
        };
      });
      setFilteredRiskGroups((prevState) => {
        const newObject = {
          notified: false,
          isCompleted: false,
          // _id: generateRandomID(),
          risk_score: 0,
          risk_category: "",
          likelihood: "",
          impact: "",
          risk_factor: "",
          risk_owner: "",
          risk_description: "N/A",
          planned_action: "N/A",
          consequence: "N/A",
          risk_color: "none",
          factor_opt: "",
        };

        const updatedGroup = Array.isArray(prevState[selectedGroup])
          ? [...prevState[selectedGroup], newObject]
          : [newObject];

        return {
          ...prevState,
          [selectedGroup]: updatedGroup,
        };
      });
    }
  };

  const generateRiskReport1 = async () => {
    try {
      setLoading(true);
      const generateRiskReportResponse = await generateRiskReport(
        propsData.opportunityData._id,
        propsData.customerId,
        totalRiskScoreByCat,
        riskScoreByCat,
        OppScoreByCat,
        propsData.opportunityData.risk_identification?.slice(0),
        propsData.opportunityData.opportunity_identification,
        riskCount,
        oppCount
      );

      if (generateRiskReportResponse && generateRiskReportResponse.data) {
        // Download the document
        downloadDocs(generateRiskReportResponse.data.fileName);
      } else {
        toastRef.current.showToast({
          type: 'error',
          message: 'No data available for generating the risk report.'
        });
      }
    } catch (error) {
      // Handle any errors during the risk report generation process
      toastRef.current.showToast({
        type: 'error',
        message: 'Failed to generate the risk report. Please try again or contact Admin.'
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setRiskTypeData((prevRiskTypeData) => {
      const newRiskTypeData = [...prevRiskTypeData];

      propsData.opportunityData?.risk_identification != undefined && propsData.opportunityData?.risk_identification.length > 0 && propsData.opportunityData?.risk_identification.forEach((riskItem) => {
        const riskTypeItem = propsData?.riskType?.find(
          (type) => type._id === riskItem.risk_type
        );

        if (
          riskTypeItem &&
          !newRiskTypeData.some((type) => type._id === riskItem.risk_type)
        ) {
          newRiskTypeData.push(riskTypeItem);
        }
      });

      return newRiskTypeData;
    });

    const riskGroupsFormat = propsData.opportunityData?.risk_identification
      ?.slice(0)
      ?.reduce((acc, riskItem) => {
        const riskTypeLabel = propsData.riskType.find(
          (type) => type._id === riskItem.risk_type
        )?.label;

        if (riskTypeLabel) {
          if (!acc[riskTypeLabel]) {
            acc[riskTypeLabel] = [];
          }
          acc[riskTypeLabel].push(...riskItem.risk_details);
        }
        return acc;
      }, {});
    setRiskGroups(riskGroupsFormat);
    setFilteredRiskGroups(riskGroupsFormat);
  }, [propsData.riskType]);

  const [selectedItems, setSelectedItems] = useState({});
  const handleCheckboxChange = (e, label) => {
    setSelectedGroup((prevSelectedGroup) => {
      if (e.checked) {
        return label;
      } else {
        return prevSelectedGroup === label ? "" : prevSelectedGroup;
      }
    });
  };

  const handleCheckboxChange123 = (group, id, index, e) => {
    setSelectedItems((prev) => ({
      ...prev,
      [group]: {
        ...prev[group],
        [index]: e.target.checked,
      },
    }));
  };
  const handleGroupCheckboxChange = (e, group, index) => {
    if (e.checked) {
      const allChecked = (riskGroups[group] || []).every(
        (item, idx) => selectedItems[group]?.[idx]
      );
      setSelectedItems((prev) => ({
        ...prev,
        [group]: Object.fromEntries(
          (riskGroups[group] || []).map((item, idx) => [idx, !allChecked])  // Use index instead of _id
        ),
      }));
    } else {
      setSelectedItems((prev) => ({
        ...prev,
        [group]: {}
      }));
    }
  };

  const handleDelete = () => {
    setRiskGroups((prevState) => {
      const updatedGroups = { ...prevState };
      Object.keys(selectedItems).forEach((group) => {
        const checkedIndexes = Object.keys(selectedItems[group] || {}).filter(
          (index) => selectedItems[group][index]
        );
        const filteredItems = (prevState[group] || []).filter(
          (item, idx) => !checkedIndexes.includes(String(idx))
        );

        if (filteredItems.length === 0) {
          delete updatedGroups[group];
        } else {
          updatedGroups[group] = filteredItems;
        }
      });

      const remainingGroups = Object.keys(updatedGroups);

      setRiskTypeData((prevData) => {
        const newRiskTypeData = prevData.filter((option) =>
          remainingGroups.includes(option.label)
        );

        return newRiskTypeData;
      });

      setSelectedItems({});
      setSelectedGroup("");

      return updatedGroups;
    });
    setFilteredRiskGroups((prevState) => {
      const updatedGroups = { ...prevState };

      Object.keys(selectedItems).forEach((group) => {
        const checkedIndexes = Object.keys(selectedItems[group] || {}).filter(
          (index) => selectedItems[group][index]
        );
        const filteredItems = (prevState[group] || []).filter(
          (item, idx) => !checkedIndexes.includes(String(idx))
        );

        if (filteredItems.length === 0) {
          delete updatedGroups[group];
        } else {
          updatedGroups[group] = filteredItems;
        }
      });

      const remainingGroups = Object.keys(updatedGroups);

      setRiskTypeData((prevData) => {
        const newRiskTypeData = prevData.filter((option) =>
          remainingGroups.includes(option.label)
        );
        return newRiskTypeData;
      });

      setSelectedItems({});
      setSelectedGroup("");

      return updatedGroups;
    });
  };
  const paginatedGroups = (riskGroups != undefined || riskGroups != null) ? Object.keys(riskGroups)?.slice(first, first + rows) : [];
  const totalRecords = (riskGroups != undefined || riskGroups != null) ? Object.values(riskGroups)?.reduce(
    (acc, group) => acc + group.length,
    0
  ) : 0;
  useEffect(() => {
    loadRiskDataList();
  }, [propsData.opportunityData]);

  const loadRiskDataList = () => {
    const details = propsData.opportunityData.risk_identification?.slice(0);
    const typeModel = [];
    const count = { Low: 0, Medium: 0, High: 0 };

    details?.forEach((item) => {
      const risk = _.filter(propsData.riskType, { _id: item.risk_type });
      if (!_.isEmpty(risk)) {
        item.risk_typeLabel = risk[0].label;
        typeModel.push({ label: risk[0].label, id: risk[0]._id });

        item.risk_details.forEach((detail) => {
          if (!_.isEmpty(detail.risk_category)) {
            const riskCat = _.filter(propsData.riskCategory, {
              _id: detail.risk_category,
            });

            if (!_.isEmpty(riskCat)) {
              const riskScore = detail.risk_score;
              let riskColor = "none";
              if (riskScore >= 1 && riskScore <= 4) {
                riskColor = "#008000";
                count.Low += 1;
              } else if (riskScore >= 5 && riskScore <= 14) {
                riskColor = "#ffa500";
                count.Medium += 1;
              } else if (riskScore >= 15 && riskScore <= 25) {
                riskColor = "#ff0000";
                count.High += 1;
              }

              detail.risk_color = riskColor;
              detail.risk_catLabel = riskCat[0].label;

              const tmpFactor = `${risk[0].label}##${riskCat[0].label}`;
              const tmpOpts = _.filter(
                _.find(propsData.data, { display_name: tmpFactor })
                  .option_choice,
                { status: "active" }
              );

              detail.factor_opt = tmpOpts;
            }
          }
        });
      }
    });
    setRiskDetails(details);
    setRiskTypemodel(typeModel);
    setRiskCount(count);
    calcTotalRiskScore();
  };

  const opportunityCompleted = (row, e, index) => {
    setOpportunityIdentification((prevOpp) =>
      prevOpp.map((item, ind) =>
        ind === index ? { ...item, isCompleted: e.checked } : item
      )
    );

    const enduserString = localStorage.getItem("enduser");
    if (enduserString) {
      const enduser = JSON.parse(enduserString);
      if (enduser) {
        if (opportunityIdentification[index]._id != undefined) {
          if (opportunityIdentification[index].action_owner === enduser.userid) {
            setIsCompletedPopup(true);
            setIsCompletedData(row);
          } else {
            setNotIsCompletedPopup(true);
            setNotIsCompletedData(row);
          }
        } else {
          toastRef.current.showToast({
            type: 'error',
            message: "Please save the task"
          });
          setIsOppCompletedState(true);
          setOppCompletedIndex(index)
        }
      } else {
        navigate("/login")
        localStorage.clear()
      }
    }
  };

  useEffect(() => {
    if (isCompletedState && completedIndex >= 0 && currentGroup != null) {
      setRiskGroups((prevGroups) => ({
        ...prevGroups,
        [currentGroup]: prevGroups[currentGroup].map((item, ind) =>
          ind === completedIndex ? { ...item, isCompleted: false } : item
        ),
      }));
      setIsCompletedState(false)
    }
  }, [isCompletedState, completedIndex, currentGroup])

  useEffect(() => {
    if (isOppCompletedState && oppCompletedIndex >= 0) {
      setOpportunityIdentification((prevOpp) =>
        prevOpp.map((item, ind) =>
          ind === oppCompletedIndex ? { ...item, isCompleted: false } : item
        )
      );
      setIsOppCompletedState(false)
    }
  }, [isOppCompletedState, oppCompletedIndex])

  const riskCompleted = (row, group, e, index) => {
    if (row && row.isCompleted) {
      setRiskGroups((prevGroups) => ({
        ...prevGroups,
        [group]: prevGroups[group].map((item, ind) =>
          ind === index ? { ...item, isCompleted: false } : item
        ),
      }));
      return;
    }
    setRiskGroups((prevGroups) => ({
      ...prevGroups,
      [group]: prevGroups[group].map((item, ind) =>
        ind === index ? { ...item, isCompleted: e.target.checked } : item
      ),
    }));
    setGroupForPopup(group);
    setCurrentRowId(index);
    setCurrentGroup(group);

    const enduserString = localStorage.getItem("enduser");
    if (enduserString) {
      const enduser = JSON.parse(enduserString);
      if (enduser) {
        if (riskGroups[group][index]._id != undefined) {
          if (riskGroups[group][index].action_owner === enduser.userid) {
            setIsCompletedPopup1(true);
            setIsCompletedData1(row);
          } else {
            setNotIsCompletedPopup1(true);
            setNotIsCompletedData1(row);
          }
        } else {
          toastRef.current.showToast({
            type: 'error',
            message: "Please save the task"
          });
          setIsCompletedState(true);
          setCompletedIndex(index)
        }
      } else {
        navigate("/login")
        localStorage.clear()
      }
    }
  };

  const [riskManagement, setRiskManagement] = useState([]);
  const [riskManagementGroup, setRiskManagementGroup] = useState("");
  const [riskManagementIndex, setRiskManagementIndex] = useState(0);
  const [riskManagementModals, setRiskManagementModals] = useState(false);
  const [editRiskManagementModals, setEditRiskManagementModals] =
    useState(false);
  const riskManagementModal = (row, group) => {
    setRiskManagement(row);
    setRiskManagementGroup(group);
    setRiskManagementModals(true);
  };
  const closeRiskManagementModal = () => {
    setRiskManagement([]);
    setRiskManagementGroup("");
    setRiskManagementModals(false);
  };
  const editRiskManagementModal = (row, group, index) => {
    setRiskManagement(row);
    setRiskManagementIndex(index)
    setRiskManagementGroup(group);
    setEditRiskManagementModals(true);
  };
  const closeEditRiskManagementModal = () => {
    setLoading(false)
    setRiskManagement([]);
    setRiskManagementGroup("");
    setEditRiskManagementModals(false);
  };
  const closeIsCompletedPopup = () => {
    setIsCompletedPopup(false);
    setOpportunityIdentification((prevOpp) =>
      prevOpp.map((item) =>
        item._id === isCompletedData._id ? { ...item, isCompleted: false } : item
      )
    );
    setIsCompletedData(null);
  };
  const closeNotIsCompletedPopup = () => {

    setNotIsCompletedPopup(false);
    setOpportunityIdentification((prevOpp) =>
      prevOpp.map((item) =>
        item._id === notIsCompletedData._id ? { ...item, isCompleted: false } : item
      )
    );
    setNotIsCompletedData(null);
  };

  const closeIsCompletedPopup1 = () => {
    setIsCompletedPopup1(false);
    setIsCompletedData1(null);
    if (currentGroup && currentRowId !== null && currentRowId !== undefined) {
      setRiskGroups((prevGroups) => ({
        ...prevGroups,
        [currentGroup]: prevGroups[currentGroup].map((item, ind) =>
          ind === currentRowId ? { ...item, isCompleted: false } : item
        ),
      }));
      setFilteredRiskGroups((prevGroups) => ({
        ...prevGroups,
        [currentGroup]: prevGroups[currentGroup].map((item, ind) =>
          ind === currentRowId ? { ...item, isCompleted: false } : item
        ),
      }));

    }
    setCurrentRowId(null); // Reset current row ID
    setCurrentGroup(null); // Reset current group
  };

  const closeNotIsCompletedPopup1 = () => {
    setNotIsCompletedPopup1(false);
    if (currentGroup && currentRowId !== null && currentRowId !== undefined) {
      setRiskGroups((prevGroups) => ({
        ...prevGroups,
        [currentGroup]: prevGroups[currentGroup].map((item, ind) =>
          ind === currentRowId ? { ...item, isCompleted: false } : item
        ),
      }));
      setFilteredRiskGroups((prevGroups) => ({
        ...prevGroups,
        [currentGroup]: prevGroups[currentGroup].map((item, ind) =>
          ind === currentRowId ? { ...item, isCompleted: false } : item
        ),
      }));
    }
    setNotIsCompletedData1(null);
  };

  const handleRiskIdentificationDescription = (e) => {
    setSelectedRiskToView((prevData) => ({
      ...prevData,
      risk_description: e.target.value,
    }));
  };
  const handleRiskIdentificationConsequence = (e) => {
    setSelectedRiskToView((prevData) => ({
      ...prevData,
      consequence: e.target.value,
    }));
  };
  const handleRiskIdentificationPlannedAction = (e) => {
    setSelectedRiskToView((prevData) => ({
      ...prevData,
      planned_action: e.target.value,
    }));
  };
  const addRiskIdentificationData = () => {
    setLoading(true)
    if (selectedRiskToView.risk_description != 'N/A') {
      setRiskGroups((prevGroups) => ({
        ...prevGroups,
        [selectedGroupToView]: prevGroups[selectedGroupToView].map((item, ind) =>
          ind === selectedRiskGroupIndex
            ? {
              ...item,
              risk_description: selectedRiskToView.risk_description,
              consequence: selectedRiskToView.consequence,
              planned_action: selectedRiskToView.planned_action,
            }
            : item
        ),
      }));
      setFilteredRiskGroups((prevGroups) => ({
        ...prevGroups,
        [selectedGroupToView]: prevGroups[selectedGroupToView].map((item, ind) =>
          ind === selectedRiskGroupIndex
            ? {
              ...item,
              risk_description: selectedRiskToView.risk_description,
              consequence: selectedRiskToView.consequence,
              planned_action: selectedRiskToView.planned_action,
            }
            : item
        ),
      }));
      closeEditRiskIdentification();
    } else {
      toastRef.current.showToast({
        type: "error",
        message: "Risk Description is mandatory"
      });
    }
  };
  const addOppIdentificationData = () => {
    setLoading(true)
    setOpportunityIdentification((prevOpp) =>
      prevOpp.map((item, ind) =>
        ind === oppIdentifyIndex ? selectedToView : item
      )
    );
    setFilterOpportunityIdentification((prevOpp) =>
      prevOpp.map((item, ind) =>
        ind === oppIdentifyIndex ? selectedToView : item
      )
    );
    setSelectedToView([])

    closeEditOppIdentification();
  };
  const addOppManagementData = () => {
    setLoading(true)
    setOpportunityIdentification((prevOpp) =>
      prevOpp.map((item, ind) =>
        ind === oppManageIndex ? selectedToView1 : item
      )
    );
    setFilterOpportunityIdentification((prevOpp) =>
      prevOpp.map((item, ind) =>
        ind === oppManageIndex ? selectedToView1 : item
      )
    );
    setSelectedToView1([])

    closeEditOppManagement();
  };
  const handleRiskManagementActionTaken = (e) => {
    setRiskManagement((prevData) => ({
      ...prevData,
      action_taken: e.target.value,
    }));
  };
  const handleRiskManagementProgrammeImpact = (e) => {
    setRiskManagement((prevData) => ({
      ...prevData,
      ["programme_impact"]: e.target.value,
    }));
  };
  const handleRiskManagementComments = (e) => {
    setRiskManagement((prevData) => ({
      ...prevData,
      ["comments"]: e.target.value,
    }));
  };
  const handleRiskComment = (e) => {
    setGlobalOpportunityData((prevData) => ({
      ...prevData,
      risk_summary: {
        ...prevData.risk_summary,
        risk_comment: e.target.value,
      },
    }));
  };
  const addRiskManagementData = () => {
    setLoading(true)
    setRiskGroups((prevGroups) => ({
      ...prevGroups,
      [riskManagementGroup]: prevGroups[riskManagementGroup].map((item, ind) =>
        ind === riskManagementIndex
          ? {
            ...item,
            action_taken: riskManagement.action_taken,
            programme_impact: riskManagement.programme_impact,
            comments: riskManagement.comments,
          }
          : item
      ),
    }));
    setFilteredRiskGroups((prevGroups) => ({
      ...prevGroups,
      [riskManagementGroup]: prevGroups[riskManagementGroup].map((item, ind) =>
        ind === riskManagementIndex
          ? {
            ...item,
            action_taken: riskManagement.action_taken,
            programme_impact: riskManagement.programme_impact,
            comments: riskManagement.comments,
          }
          : item
      ),
    }));
    closeEditRiskManagementModal();
  };

  const renderFooter = () => {
    return (
      <div className="cancel-footer">
        <div className="align-center justify-end pb-0">
          <ButtonElement label="Cancel" className="cancel-new-button" onClick={() => closeEditRiskIdentification()} />
          <ButtonElement
            label="Save"
            className="save-button"
            onClick={addRiskIdentificationData}
          />
        </div>
      </div>
    );
  };
  const riskActionOwnerChange = (e, selectedRow, group, index) => {
    setRiskGroups((prevGroups) => ({
      ...prevGroups,
      [group]: prevGroups[group].map((item, ind) =>
        ind === index
          ? { ...item, action_owner: e.target.value._id }
          : item
      ),
    }));
    setFilteredRiskGroups((prevGroups) => ({
      ...prevGroups,
      [group]: prevGroups[group].map((item, ind) =>
        ind === index
          ? { ...item, action_owner: e.target.value._id }
          : item
      ),
    }));
  };
  const riskActionByDate = (e, selectedRow, group, index) => {
    setRiskGroups((prevGroups) => ({
      ...prevGroups,
      [group]: prevGroups[group].map((item, ind) =>
        ind === index
          ? { ...item, action_bydate: formatDate(e.target.value) }
          : item
      ),
    }));
    setFilteredRiskGroups((prevGroups) => ({
      ...prevGroups,
      [group]: prevGroups[group].map((item, ind) =>
        ind === index
          ? { ...item, action_bydate: formatDate(e.target.value) }
          : item
      ),
    }));
  };
  const handlePotentialCostTextChange = (e, selectedRow, group, index) => {
    setRiskGroups((prevGroups) => ({
      ...prevGroups,
      [group]: prevGroups[group].map((item, ind) =>
        ind === index
          ? { ...item, potential_saving: e.target.value }
          : item
      ),
    }));
    setFilteredRiskGroups((prevGroups) => ({
      ...prevGroups,
      [group]: prevGroups[group].map((item, ind) =>
        ind === index
          ? { ...item, potential_saving: e.target.value }
          : item
      ),
    }));
  };
  const handleActualCostTextChange = (e, selectedRow, group, index) => {
    setRiskGroups((prevGroups) => ({
      ...prevGroups,
      [group]: prevGroups[group].map((item, ind) =>
        ind === index
          ? { ...item, actual_saving: e.target.value }
          : item
      ),
    }));
    setFilteredRiskGroups((prevGroups) => ({
      ...prevGroups,
      [group]: prevGroups[group].map((item, ind) =>
        ind === index
          ? { ...item, actual_saving: e.target.value }
          : item
      ),
    }));
  };
  const renderRiskManagementFooter = () => {
    return (
      <div className="cancel-footer">
        <div className="align-center justify-end pb-0">
          <ButtonElement
            label="Cancel"
            className="cancel-new-button"
            onClick={closeEditRiskManagementModal}
          />
          <ButtonElement
            label="Save"
            className="save-button"
            onClick={addRiskManagementData}
          />
        </div>
      </div>
    );
  };

  const renderFooterRiskManage = () => {
    return (
      <div className="cancel-footer">
        <div className="align-center justify-end pb-0">
          <ButtonElement
            label="Cancel"
            className="cancel-new-button"
            onClick={closeRiskManagementModal}
          />
        </div>
      </div>
    );
  }

  // const modalOppCompleted = async () => {

  //   var parentIndex =
  //     globalOpportunityData.opportunity_identification.findIndex(
  //       (obj) => obj._id === isCompletedData._id
  //     );
  //   var index = 0;
  //   const tmpOppIden = _.cloneDeep(
  //     globalOpportunityData.opportunity_identification[parentIndex]
  //   );
  //   tmpOppIden.isCompleted = true;
  //   const riskActionCompleteResponse = await riskActionComplete(
  //     globalOpportunityData._id,
  //     propsData.customerId,
  //     parentIndex,
  //     index,
  //     tmpOppIden,
  //     "oppMgmt"
  //   );
  //   if (riskActionCompleteResponse.data.success) {
  //     toastRef.current.showToast({
  //       type: "success",
  //       message: riskActionCompleteResponse.data.message,
  //     });
  //     setOpportunityIdentification((prevOpp) =>
  //       prevOpp.map((item) =>
  //         item._id === isCompletedData._id ? { ...item, isCompleted: true } : item
  //       )
  //     );
  //     setIsCompletedPopup(false)
  //   } else {
  //     toastRef.current.showToast({
  //       type: "error",
  //       message: riskActionCompleteResponse.data.message,
  //     });
  //     setIsCompletedPopup(false)
  //   }
  // };
  const modalOppCompleted = async () => {
    try {
      setLoading(true);
      // Find the parent index based on the _id of the completed data
      const parentIndex =
        globalOpportunityData.opportunity_identification.findIndex(
          (obj) => obj._id === isCompletedData._id
        );

      const index = 0;
      const tmpOppIden = _.cloneDeep(
        globalOpportunityData.opportunity_identification[parentIndex]
      );
      tmpOppIden.isCompleted = true;

      // Call API to mark the opportunity as completed
      const riskActionCompleteResponse = await riskActionComplete(
        globalOpportunityData._id,
        propsData.customerId,
        parentIndex,
        index,
        tmpOppIden,
        "oppMgmt"
      );

      // Handle success or failure of the API call
      if (riskActionCompleteResponse && riskActionCompleteResponse.data.success) {
        toastRef.current.showToast({
          type: "success",
          message: riskActionCompleteResponse.data.message,
        });

        setOpportunityIdentification((prevOpp) =>
          prevOpp.map((item) =>
            item._id === isCompletedData._id ? { ...item, isCompleted: true } : item
          )
        );
        setIsCompletedPopup(false);
      } else {
        toastRef.current.showToast({
          type: "error",
          message: riskActionCompleteResponse.data.message,
        });
        setIsCompletedPopup(false);
      }
    } catch (error) {
      // Handle errors during the API request
      toastRef.current.showToast({
        type: "error",
        message: "Failed to complete the opportunity. Please try again or contact Admin."
      });
    } finally {
      setLoading(false);
    }
  };

  // const modalRiskCompleted = async () => {
  //   var parentIndex = globalOpportunityData.risk_identification.findIndex(
  //     (obj) => obj.risk_typeLabel === groupForPopup
  //   );
  //   var index = globalOpportunityData.risk_identification[
  //     parentIndex
  //   ].risk_details.findIndex((obj) => obj._id === isCompletedData1._id);

  //   const tmpRiskData = _.cloneDeep(
  //     globalOpportunityData.risk_identification[parentIndex].risk_details[index]
  //   );
  //   tmpRiskData.isCompleted = true;
  //   const riskActionCompleteResponse = await riskActionComplete(
  //     globalOpportunityData._id,
  //     propsData.customerId,
  //     parentIndex,
  //     index,
  //     tmpRiskData,
  //     "riskMgmt"
  //   );
  //   if (riskActionCompleteResponse.data.success) {
  //     var clearCompNotify = await clearCompletedNotification(tmpRiskData._id)
  //     if (clearCompNotify.data) {
  //       if (clearCompNotify.data.status) {
  //         socket.emit('pushNotifications', propsData.customerId)
  //       }
  //     }
  //     setRiskGroups((prevGroups) => ({
  //       ...prevGroups,
  //       [currentGroup]: prevGroups[currentGroup].map((item) =>
  //         item._id === currentRowId ? { ...item, isCompleted: true } : item
  //       ),
  //     }));
  //     toastRef.current.showToast({
  //       type: "success",
  //       message: riskActionCompleteResponse.data.message,
  //     });
  //     setIsCompletedPopup1(false)
  //   } else {
  //     toastRef.current.showToast({
  //       type: "error",
  //       message: riskActionCompleteResponse.data.message,
  //     });
  //     setIsCompletedPopup1(false)
  //   }
  // };

  const modalRiskCompleted = async () => {
    try {
      setLoading(true); // Start loading spinner
      setRiskGroups((prevGroups) => ({
        ...prevGroups,
        [currentGroup]: prevGroups[currentGroup].map((item, ind) =>
          ind === currentRowId ? { ...item, isCompleted: true } : item
        ),
      }));
      // Find the parent index and risk details index
      const parentIndex = globalOpportunityData.risk_identification.findIndex(
        (obj) => obj.risk_typeLabel === groupForPopup
      );
      if (parentIndex === -1) {
        toastRef.current.showToast({
          type: "error",
          message: "Risk type label not found",
        });
        setLoading(false);
        return;
      }
      const index = globalOpportunityData.risk_identification[
        parentIndex
      ].risk_details.findIndex((obj) => obj._id === isCompletedData1._id);

      if (index === -1) {
        toastRef.current.showToast({
          type: "error",
          message: "Risk detail not found",
        });
        setLoading(false);
        return;
      }

      // Clone and mark the risk as completed
      const tmpRiskData = _.cloneDeep(
        globalOpportunityData.risk_identification[parentIndex].risk_details[index]
      );
      if (!tmpRiskData) {
        toastRef.current.showToast({
          type: "error",
          message: "Failed to clone risk data",
        });
        setLoading(false);
        return;
      }
      tmpRiskData.isCompleted = true;

      // Call API to complete the risk action
      const riskActionCompleteResponse = await riskActionComplete(
        globalOpportunityData._id,
        propsData.customerId,
        parentIndex,
        index,
        tmpRiskData,
        "riskMgmt"
      );

      if (!riskActionCompleteResponse || !riskActionCompleteResponse.data) {
        toastRef.current.showToast({
          type: "error",
          message: "No response from risk action complete API",
        });
        setLoading(false);
        return;
      }

      if (riskActionCompleteResponse && riskActionCompleteResponse.data.success) {
        // Clear notification for completed risk
        const clearCompNotify = await clearCompletedNotification(tmpRiskData._id);
        if (clearCompNotify && clearCompNotify.data && clearCompNotify.data.status) {
          socket.emit('pushNotifications', propsData.customerId);
        }

        // Update the risk groups in the state
        setRiskGroups((prevGroups) => ({
          ...prevGroups,
          [currentGroup]: prevGroups[currentGroup].map((item) =>
            item._id === currentRowId ? { ...item, isCompleted: true } : item
          ),
        }));

        // Show success toast
        toastRef.current.showToast({
          type: "success",
          message: riskActionCompleteResponse.data.message,
        });

        setIsCompletedPopup1(false);
      } else {
        // Show error toast on failure
        toastRef.current.showToast({
          type: "error",
          message: riskActionCompleteResponse.data.message,
        });
        setIsCompletedPopup1(false);
      }
    } catch (error) {
      // Handle errors during the API request
      toastRef.current.showToast({
        type: "error",
        message: "Failed to complete the risk. Please try again or contact Admin.",
      });
    } finally {
      setLoading(false);
    }
  };


  const isCompletedFooter = () => {
    return (
      <div className="cancel-footer">
        <div className="align-center justify-end pb-0">
          <ButtonElement
            label="No"
            className="cancel-new-button"
            onClick={closeIsCompletedPopup}
          />
          <ButtonElement
            label="Yes"
            className="save-button"
            onClick={modalOppCompleted}
          />
        </div>
      </div>
    );
  };
  const notIsCompletedFooter = () => {
    return (
      <div className="cancel-footer">
        <div className="align-center justify-end pb-0">
          <ButtonElement
            label="Close"
            className="cancel-new-button"
            onClick={closeNotIsCompletedPopup}
          />
        </div>
      </div>
    );
  };

  const isCompletedFooter1 = () => {
    return (
      <div className="cancel-footer">
        <div className="align-center justify-end pb-0">
          <ButtonElement
            label="No"
            className="cancel-new-button"
            onClick={closeIsCompletedPopup1}
          />
          <ButtonElement
            label="Yes"
            className="save-button"
            onClick={modalRiskCompleted}
          />
        </div>
      </div>
    );
  };

  const notIsCompletedFooter1 = () => {
    return (
      <div className="cancel-footer">
        <div className="align-center justify-end pb-0">
          <ButtonElement
            label="Close"
            className="cancel-new-button"
            onClick={closeNotIsCompletedPopup1}
          />
        </div>
      </div>
    );
  };

  const dropdownRef = useRef(null);
  const handleOutsideClick = (event) => {
    if (showDropdown) {
      const target = event.target;
      const dropdownButton = document.querySelector('.clear-filter-button');
      const dropdownContent = document.querySelector('.s-field');
      const multiSelectInput = document.querySelector('.p-multiselect-filter');

      // Check if the clicked element is not in the dropdown, the button, or any MultiSelect/single select items
      if (
        !dropdownContent.contains(target) &&
        target !== dropdownButton &&
        target !== multiSelectInput &&
        !target.closest('.p-multiselect-item') && // MultiSelect items
        !target.closest('.p-dropdown-item') // Single select dropdown items
      ) {
        setShowDropdown(false);
      }
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [showDropdown]);

  const dropdownRef1 = useRef(null);
  const handleOutsideClick1 = (event) => {

    if (showDropdown1) {
      const target = event.target;
      const dropdownButton = document.querySelector('.edit-option-button'); // Button class
      const dropdownContent = document.querySelector('.s-field');
      const multiSelectInput = document.querySelector('.p-multiselect-filter');
      const formGroup = document.querySelector('.form-group.row.align-items-center.mb-0.mt-0'); // Updated div class

      // Check if the clicked element is not in the dropdown, the button, the form group, or any MultiSelect/single select items
      if (
        !dropdownContent.contains(target) &&
        !dropdownButton.contains(target) && // Ensure dropdown button is excluded
        !formGroup.contains(target) && // Check if clicked inside the updated form group
        target !== multiSelectInput &&
        !target.closest('.p-multiselect-item') && // MultiSelect items
        !target.closest('.p-dropdown-item') // Single select dropdown items
      ) {
        setShowDropdown1(false);
      }
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick1);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick1);
    };
  }, [showDropdown1]);

  const handleButtonClick = () => {
    setShowVideo(true);
  };

  const closeVideo = () => {
    setShowVideo(false);
  };


  return (
    <>
      <div className="col-md-12 text-right">
        <ButtonElement className="upload-button" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
      </div>
      {propsData.pipelineRiskSections?.map((section, index) => {
        return (
          <div key={index} className="mt-10 risks-tab">
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            <Accordion activeIndex={0}>
              <AccordionTab header={section?.display_name} disabled>
                {section.section_name === "Risk Summary" && (
                  <div className="new-field d-flex">
                    <div className="col-md-6 pl-0">
                      {propsData.pipelineStakeFields?.find(
                        (project) => project.field_name === "Risks"
                      )?.field_status && (
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">
                                {
                                  propsData.projectSelectFields?.find(
                                    (project) => project.field_name === "Risks"
                                  ).display_name
                                }
                                :
                              </label>
                            </div>

                            <div className="col-md-1 pl-0">
                              {propsData.customerTooltipRisks?.risk_summary?.risks?.status ==
                                true && (
                                  <div>
                                    <Tooltip target=".custom-target-icon" />

                                    <i
                                      className="custom-target-icon pi pi-info-circle tooltip-font"
                                      data-pr-tooltip={
                                        propsData.customerTooltipRisks?.risk_summary?.risks
                                          ?.text
                                      }
                                      data-pr-position="right"
                                    ></i>
                                  </div>
                                )}
                            </div>
                            <div className="col pr-0">
                              <Controller
                                name="Risks"
                                control={control}
                                defaultValue={propsData.risks.filter(
                                  (item) => item.label === globalOpportunityData?.opportunity.risks
                                )[0]}
                                style={{ innerHeight: 10 }}
                                render={({ field }) => {
                                  return (
                                    <DropdownElement
                                      id="Risks"
                                      name="Risks"
                                      options={(propsData.risks != undefined && propsData.risks.length > 0) ? propsData.risks : []}
                                      value={
                                        field.value ||
                                        propsData.risks.filter(
                                          (item) => item.label === globalOpportunityData?.opportunity.risks
                                        )[0]
                                      }
                                      optionLabel="label"
                                      placeholder="-- Please select --"
                                      className="w-full"
                                      {...field}
                                      // ref={(el) => {
                                      //   props.setElement((prevData) => ({
                                      //     ...prevData,
                                      //     ["Risks"]: el,
                                      //   }));
                                      // }}
                                      onChange={(e) => {
                                        setGlobalOpportunityData((prevData) => ({
                                          ...prevData,
                                          opportunity: {
                                            ...prevData.opportunity,
                                            risks: e.value.label,
                                          }
                                        }));
                                        props.computeScore(0, "Risks", e.value, propsData.risks.filter(
                                          (item) => item.label === globalOpportunityData?.opportunity.risks
                                        )[0]);
                                        field.onChange(e.value);
                                      }}
                                    />
                                  );
                                }}
                              />
                            </div>
                          </div>
                        )}
                      {propsData.pipelineRiskFields?.find(
                        (project) => project.field_name === "Risk Comment"
                      )?.field_status && (
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">
                                {
                                  propsData.pipelineRiskFields?.find(
                                    (project) =>
                                      project.field_name === "Risk Comment"
                                  ).display_name
                                }
                                :
                              </label>
                            </div>

                            <div className="col-md-1 pl-0">
                              {propsData.customerTooltipRisks?.risk_summary?.risk_comment
                                ?.status == true && (
                                  <div>
                                    <Tooltip target=".custom-target-icon" />

                                    <i
                                      className="custom-target-icon pi pi-info-circle tooltip-font"
                                      data-pr-tooltip={
                                        propsData.customerTooltipRisks?.risk_summary
                                          ?.risk_comment?.text
                                      }
                                      data-pr-position="right"
                                    ></i>
                                  </div>
                                )}
                            </div>
                            <div className="col pr-0">
                              <TextareaElement
                                id="risk_summary"
                                name="risk_summary"
                                defaultValue={
                                  propsData.opportunityData?.risk_summary
                                    ?.risk_comment
                                }
                                onChange={(e) => {
                                  handleRiskComment(e);
                                }}
                                //   register={register("summary.client_desc")}
                                className="w-full"
                                rows={3}
                              />
                            </div>
                          </div>
                        )}
                      {propsData.pipelineRiskFields?.find(
                        (project) => project.field_name === "Cost Plan Provided"
                      )?.field_status && (
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">
                                {
                                  propsData.pipelineRiskFields?.find(
                                    (project) =>
                                      project.field_name === "Cost Plan Provided"
                                  ).display_name
                                }
                                :
                              </label>
                            </div>

                            <div className="col-md-1 pl-0">
                              {propsData.customerTooltipRisks?.risk_summary
                                ?.cost_plan_provided?.status == true && (
                                  <div>
                                    <Tooltip target=".custom-target-icon" />

                                    <i
                                      className="custom-target-icon pi pi-info-circle tooltip-font"
                                      data-pr-tooltip={
                                        propsData.customerTooltipRisks?.risk_summary
                                          ?.cost_plan_provided?.text
                                      }
                                      data-pr-position="right"
                                    ></i>
                                  </div>
                                )}
                            </div>
                            <div className="col pr-0">
                              <RadioElement
                                options={[
                                  { key: "yes", name: "Yes" },
                                  { key: "no", name: "No" },
                                ]}
                                onChangeRadio={(value) => {
                                  handleCostPlanChange(value);
                                }}
                                value={
                                  globalOpportunityData.risk_summary
                                    ?.cost_plan_provided
                                }
                                className="radio-group-class" // Add any additional classes if necessary
                                disabled={false} // Adjust the disabled prop as needed
                              />
                            </div>
                          </div>
                        )}
                      {propsData.pipelineRiskFields?.find(
                        (project) => project.field_name === "Cost Base Date"
                      )?.field_status && (
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">
                                {
                                  propsData.pipelineRiskFields?.find(
                                    (project) =>
                                      project.field_name === "Cost Base Date"
                                  ).display_name
                                }
                                :
                              </label>
                            </div>

                            <div className="col-md-1 pl-0">
                              {propsData.customerTooltipRisks?.risk_summary?.cost_base_date
                                ?.status == true && (
                                  <div>
                                    <Tooltip target=".custom-target-icon" />

                                    <i
                                      className="custom-target-icon pi pi-info-circle tooltip-font"
                                      data-pr-tooltip={
                                        propsData.customerTooltipRisks?.risk_summary
                                          ?.cost_base_date?.text
                                      }
                                      data-pr-position="right"
                                    ></i>
                                  </div>
                                )}
                            </div>
                            <div className="col pr-0">
                              <CalendarElement
                                id="cost_base_date"
                                className="ml-10"
                                defaultValue={parseDateString(
                                  globalOpportunityData?.risk_summary
                                    ?.cost_base_date
                                )}
                                value={parseDateString(
                                  globalOpportunityData.risk_summary
                                    ?.cost_base_date
                                )}
                                onChange={(e) => {
                                  handleCostBaseDateChange(e);
                                }}
                                maxLength="50"
                                placeholder="Date"
                                autocomplete="off"
                              />
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="col-md-6 pl-0">
                      {propsData.pipelineRiskFields?.find(
                        (project) =>
                          project.field_name === "Has planning been granted?"
                      )?.field_status && (
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">
                                {
                                  propsData.pipelineRiskFields?.find(
                                    (project) =>
                                      project.field_name ===
                                      "Has planning been granted?"
                                  ).display_name
                                }
                                :
                              </label>
                            </div>

                            <div className="col-md-1 pl-0">
                              {propsData.customerTooltipRisks?.risk_summary?.planning_granted
                                ?.status == true && (
                                  <div>
                                    <Tooltip target=".custom-target-icon" />

                                    <i
                                      className="custom-target-icon pi pi-info-circle tooltip-font"
                                      data-pr-tooltip={
                                        propsData.customerTooltipRisks?.risk_summary
                                          ?.planning_granted?.text
                                      }
                                      data-pr-position="right"
                                    ></i>
                                  </div>
                                )}
                            </div>
                            <div className="col pr-0">
                              <RadioElement
                                options={[
                                  { key: "Yes", name: "Yes" },
                                  { key: "No", name: "No" },
                                ]}
                                onChangeRadio={(value) => {
                                  handleplanningGrantedRadioChange(value);
                                }}
                                value={
                                  globalOpportunityData.risk_summary
                                    ?.planning_granted
                                }
                                className="radio-group-class" // Add any additional classes if necessary
                                disabled={false} // Adjust the disabled prop as needed
                              />
                            </div>
                          </div>
                        )}
                      {propsData.pipelineRiskFields?.find(
                        (project) =>
                          project.field_name === "Planning Reference Number"
                      )?.field_status && (
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">
                                {
                                  propsData.pipelineRiskFields?.find(
                                    (project) =>
                                      project.field_name ===
                                      "Planning Reference Number"
                                  ).display_name
                                }
                                :
                              </label>
                            </div>

                            <div className="col-md-1 pl-0">
                              {propsData.customerTooltipRisks?.risk_summary
                                ?.planning_reference_number?.status == true && (
                                  <div>
                                    <Tooltip target=".custom-target-icon" />

                                    <i
                                      className="custom-target-icon pi pi-info-circle tooltip-font"
                                      data-pr-tooltip={
                                        propsData.customerTooltipRisks?.risk_summary
                                          ?.planning_reference_number?.text
                                      }
                                      data-pr-position="right"
                                    ></i>
                                  </div>
                                )}
                            </div>
                            <div className="col pr-0">
                              <InputTextElementElement
                                className="dropdown-field-handle"
                                value={
                                  globalOpportunityData.risk_summary
                                    ?.planning_reference_number
                                }
                                name="planning_reference_number"
                                placeholder="Number"
                                onChange={(e) =>
                                  handlePlanningReferenceNumberChange(e)
                                }
                              />
                            </div>
                          </div>
                        )}
                      {propsData.pipelineRiskFields?.find(
                        (project) =>
                          project.field_name === "Planning Reference Link"
                      )?.field_status && (
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">
                                {
                                  propsData.pipelineRiskFields?.find(
                                    (project) =>
                                      project.field_name ===
                                      "Planning Reference Link"
                                  ).display_name
                                }
                                :
                              </label>
                            </div>

                            <div className="col-md-1 pl-0">
                              {propsData.customerTooltipRisks?.risk_summary
                                ?.planning_reference_link?.status == true && (
                                  <div>
                                    <Tooltip target=".custom-target-icon" />

                                    <i
                                      className="custom-target-icon pi pi-info-circle tooltip-font"
                                      data-pr-tooltip={
                                        propsData.customerTooltipRisks?.risk_summary
                                          ?.planning_reference_link?.text
                                      }
                                      data-pr-position="right"
                                    ></i>
                                  </div>
                                )}
                            </div>
                            <div className="col pr-0">
                              <InputTextElementElement
                                className="dropdown-field-handle"
                                value={
                                  globalOpportunityData.risk_summary
                                    ?.planning_reference_link
                                }
                                name="planning_reference_link"
                                placeholder="Link"
                                onChange={(e) =>
                                  handlePlanningReferenceLinkChange(e)
                                }
                              />
                            </div>
                          </div>
                        )}
                      {propsData.pipelineRiskFields?.find(
                        (project) =>
                          project.field_name === "Is there Insurance cover?"
                      )?.field_status && (
                          <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                              <label className="form-label text-left">
                                {
                                  propsData.pipelineRiskFields?.find(
                                    (project) =>
                                      project.field_name ===
                                      "Is there Insurance cover?"
                                  ).display_name
                                }
                                :
                              </label>
                            </div>

                            <div className="col-md-1 pl-0">
                              {propsData.customerTooltipRisks?.risk_summary?.insurance_cover
                                ?.status == true && (
                                  <div>
                                    <Tooltip target=".custom-target-icon" />

                                    <i
                                      className="custom-target-icon pi pi-info-circle tooltip-font"
                                      data-pr-tooltip={
                                        propsData.customerTooltipRisks?.risk_summary
                                          ?.insurance_cover?.text
                                      }
                                      data-pr-position="right"
                                    ></i>
                                  </div>
                                )}
                            </div>
                            <div className="col pr-0">
                              <RadioElement
                                options={[
                                  { key: "Yes", name: "Yes" },
                                  { key: "No", name: "No" },
                                ]}
                                onChangeRadio={(value) => {
                                  handleInsuranceCoverRadioChange(value);
                                }}
                                value={
                                  globalOpportunityData?.additional_considerations
                                    ?.insurance_cover
                                }
                                className="radio-group-class" // Add any additional classes if necessary
                                disabled={false} // Adjust the disabled prop as needed
                              />
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                )}
                {section.section_name === "Risk Score Breakdown" && (
                  <div className="flex justify-content-between">
                    <div className="card p-3 pt-4 pb-2 w-25 m-2">
                      <p className="form-label text-left flex justify-content-between w-full">
                        <strong>Risk Score :</strong>{" "}
                        {totalRiskScoreByCat.riskSum}
                      </p>

                      {Object.entries(riskScoreByCat).map(([key, value]) => (
                        <p
                          key={key}
                          className="form-label text-left flex justify-content-between w-full"
                        >
                          <span>{key}:</span> {value}
                        </p>
                      ))}
                    </div>
                    <div className="card p-3 pt-4 pb-2 w-25 m-2">
                      <p className="form-label text-left flex justify-content-between w-full">
                        <strong>Opportunity Score :</strong>{" "}
                        {totalRiskScoreByCat.riskOppSum}
                      </p>

                      {Object.entries(OppScoreByCat).map(([key, value]) => (
                        <p
                          key={key}
                          className="form-label text-left flex justify-content-between w-full"
                        >
                          <span>{key}:</span> {value}
                        </p>
                      ))}
                    </div>
                    <div className="card p-3 pt-4 pb-2 w-25 m-2">
                      <p className="form-label text-left flex justify-content-between w-full">
                        <strong>Risk Count :</strong>{" "}
                        {riskCount.Low + riskCount.Medium + riskCount.High}
                      </p>

                      <p className="form-label text-left flex justify-content-between w-full">
                        <span>Low:</span> {riskCount.Low}
                      </p>
                      <p className="form-label text-left flex justify-content-between w-full">
                        <span>Medium:</span> {riskCount.Medium}
                      </p>
                      <p className="form-label text-left flex justify-content-between w-full">
                        <span>High:</span> {riskCount.High}
                      </p>
                    </div>
                    <div className="card p-3 pt-4 pb-2 w-25 m-2">
                      <p className="form-label text-left flex justify-content-between w-full">
                        <strong>Opportunity Count :</strong>{" "}
                        {oppCount.Low + oppCount.Medium + oppCount.High}
                      </p>

                      <p className="form-label text-left flex justify-content-between w-full">
                        <span>Low:</span> {oppCount.Low}
                      </p>
                      <p className="form-label text-left flex justify-content-between w-full">
                        <span>Medium:</span> {oppCount.Medium}
                      </p>
                      <p className="form-label text-left flex justify-content-between w-full">
                        <span>High:</span> {oppCount.High}
                      </p>
                    </div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                )}

                {section.section_name === "Risk Identification" && (
                  <>
                    <div className="new-field">
                      <div className="form-group row align-items-center mb-0 mt-10">
                        {propsData.pipelineRiskFields?.find(
                          (project) => project.field_name === "Risk Type"
                        )?.field_status && (
                            <div className="col-md-6 pl-0 d-flex">
                              <div className="col-md-4 pl-0">
                                <label className="form-label text-left">
                                  {
                                    propsData.pipelineRiskFields?.find(
                                      (project) =>
                                        project.field_name === "Risk Type"
                                    ).display_name
                                  }
                                  :
                                </label>
                              </div>

                              <div className="col-md-1 pl-0">
                                {propsData.customerTooltipRisks?.risk_identification
                                  ?.risk_type?.status == true && (
                                    <div>
                                      <Tooltip target=".custom-target-icon" />

                                      <i
                                        className="custom-target-icon pi pi-info-circle tooltip-font"
                                        data-pr-tooltip={
                                          propsData.customerTooltipRisks?.risk_identification
                                            .risk_type?.text
                                        }
                                        data-pr-position="right"
                                      ></i>
                                    </div>
                                  )}
                              </div>
                              <div className="col pr-0">
                                <MultiSelectElement
                                  value={riskTypeData}
                                  options={propsData.riskType}
                                  onChangeValue={(e) => handleMultiSelect(e)}
                                  optionLabel="label"
                                  optionGroupLabel="label"
                                  optionGroupChildren="items"
                                  placeholder="Select"
                                  display="chip"
                                  className="w-full"
                                />
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                    <div>
                      <div className="col pr-0 d-flex justify-end">
                        <ButtonElement
                          icon="pi pi-filter-slash"
                          className="edit-option-button font-text"
                          onClick={resetButton1}
                        />
                        <div className="p-relative ml-20" ref={dropdownRef1}>
                          <ButtonElement
                            className="edit-option-button"
                            icon="pi pi-filter"
                            onClick={toggleDropdown1}
                          />
                          {showDropdown1 && (
                            <>
                              <div className="s-field">
                                <div className="new-field w-100">
                                  <div className="form-group row align-items-center mb-0 mt-0">
                                    <div className="col-md-5 pl-0">
                                      <label className="form-label text-left">
                                        Action Owner:
                                      </label>
                                    </div>
                                    <div className="col pr-0">
                                      <MultiSelectElement
                                        value={selectedOwnerResp}
                                        optionLabel="label"
                                        options={actionOwnersFilter}
                                        placeholder="-- Please select --"
                                        maxSelectedLabels={1}
                                        onChangeValue={(e) =>
                                          handleSelection1(e.value)
                                        }
                                        className="w-full"
                                      />
                                    </div>
                                  </div>
                                  <div className="form-group row align-items-center mb-0 mt-0">
                                    <div className="col-md-5 pl-0">
                                      <label className="form-label text-left">
                                        Status:
                                      </label>
                                    </div>
                                    <div className="col pr-0">
                                      <MultiSelectElement
                                        value={selectedStatus}
                                        optionLabel="label"
                                        options={statusFilter}
                                        placeholder="-- Please select --"
                                        maxSelectedLabels={1}
                                        onChangeValue={(e) =>
                                          handleStatusSelection1(e.value)
                                        }
                                        className="w-full"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                        <ButtonElement
                          className="edit-option-button ml-20"
                          type="button"
                          icon="pi pi-trash"
                          onClick={handleDelete}
                        />
                        <ButtonElement
                          className="edit-option-button ml-20"
                          type="button"
                          icon="pi pi-plus"
                          onClick={handleAddButtonClick}
                        />

                      </div>
                    </div>
                    <div>
                      {propsData.oppRisksTable?.find(
                        (table) => table.table_name === "Risk Identification"
                      )?.status && (
                          <div className="group-table-data pl-0">
                            <table className="group-datatable">
                              <thead className="group-table-header">
                                <tr>
                                  <th className="checkbox-header"></th>
                                  {columns1.map((headers) => (
                                    <th key={headers.header} className="width-11_5">{headers.header}</th>
                                  ))}
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody className="group-table-row">
                                {paginatedGroups.map((group, index) => (
                                  <React.Fragment key={group}>
                                    <tr>
                                      <td>
                                        <CheckboxElement
                                          checked={selectedGroup === group}
                                          onChangeCheck={(e) => {
                                            handleCheckboxChange(e, group);
                                            handleGroupCheckboxChange(e, group, index);
                                          }}
                                        ></CheckboxElement>
                                      </td>
                                      <td colSpan={9}>
                                        <b>{group}</b>
                                      </td>
                                    </tr>
                                    {Array.isArray(riskGroups[group]) &&
                                      riskGroups[group].length > 0
                                      ? riskGroups[group].map((row, index) => (
                                        <tr key={`${group}-${index}`}>
                                          <td>
                                            <CheckboxElement
                                              checked={
                                                selectedItems[group]?.[
                                                index
                                                ] || false
                                              }
                                              onChangeCheck={(e) =>
                                                handleCheckboxChange123(
                                                  group,
                                                  row._id,
                                                  index,
                                                  e
                                                )
                                              }
                                            ></CheckboxElement>
                                          </td>
                                          <td className="width-11_5">
                                            <DropdownElement
                                              onChange={(e) => {
                                                oppCatChange1(e, row, group, index);
                                              }}
                                              id={row._id}
                                              key={row._id}
                                              options={(riskCategory != undefined && riskCategory.length > 0) ? riskCategory : []}
                                              value={riskCategory.find(
                                                (obj) =>
                                                  obj._id === row.risk_category
                                              )}
                                              optionLabel="label"
                                              placeholder="-- Please select --"
                                              className={(props.errors.includes('Risk Category') && row.risk_category == '') ? 'error-tab w-150' : 'w-150'}
                                            />
                                          </td>
                                          <td className="width-11_5">
                                            <label title={row.risk_description}>
                                              {" "}
                                              {row.risk_description ||
                                                "N/A"}{" "}
                                            </label>
                                          </td>
                                          <td className="width-11_5">
                                            <DropdownElement
                                              onChange={(e) => {
                                                oppFactorChange(e, row, group, index);
                                              }}
                                              id={row._id}
                                              key={row._id}
                                              options={(row?.factor_opt != undefined && row.factor_opt.length > 0) ? row.factor_opt : []}
                                              value={
                                                row.factor_opt &&
                                                row?.factor_opt?.find(
                                                  (obj) =>
                                                    obj._id === row.risk_factor
                                                )
                                              }
                                              optionLabel="label"
                                              placeholder="-- Please select --"
                                              className="w-150"
                                            />
                                          </td>
                                          <td className="width-11_5">
                                            <label title={row.consequence}>
                                              {" "}
                                              {row.consequence || "N/A"}{" "}
                                            </label>
                                          </td>
                                          <td className="width-11_5">
                                            <DropdownElement
                                              onChange={(e) => {
                                                onLikelihoodChange1(
                                                  e,
                                                  row,
                                                  group,
                                                  index
                                                );
                                                computeLikelihoodRiskScore(
                                                  e,
                                                  row,
                                                  group,
                                                  index
                                                );
                                              }}
                                              title="1 is Low and 5 is High"
                                              id={row._id}
                                              options={(riskImpact != undefined && riskImpact.length > 0) ? riskImpact : []}
                                              value={row.likelihood}
                                              optionLabel="label"
                                              placeholder="-- Please select --"
                                              className="w-150"
                                            />
                                          </td>
                                          <td className="width-11_5">
                                            <DropdownElement
                                              onChange={(e) => {
                                                onImpactChange1(e, row, group, index);
                                                computeImpactRiskScore(
                                                  e,
                                                  row,
                                                  group,
                                                  index
                                                );
                                              }}
                                              id={row._id}
                                              options={(riskImpact != undefined && riskImpact.length > 0) ? riskImpact : []}
                                              value={row.impact}
                                              optionLabel="label"
                                              placeholder="-- Please select --"
                                              className="w-150"
                                            />
                                          </td>
                                          <td className="width-11_5">
                                            <div
                                              style={{
                                                background: `${row.risk_color}`,
                                              }}
                                              className="flex justify-content-center p-auto pt-2"
                                              key={index}
                                            >
                                              <label title={row.risk_score} className="font-color-white">
                                                {row.risk_score || "N/A"}
                                              </label>
                                            </div>
                                          </td>
                                          <td>
                                            <div
                                              className="flex justify-content-center p-auto pt-2"
                                              key={index}
                                            >
                                              <label title={row.planned_action}>
                                                {row.planned_action || "N/A"}
                                              </label>
                                            </div>
                                          </td>
                                          <td className="width-11_5">
                                            <DropdownElement
                                              onChange={(e) =>
                                                onOwnerChange1(e, row, group, index)
                                              }
                                              id={row._id}
                                              options={(propsData.relationshipOwner != undefined && propsData.relationshipOwner.length > 0) ? propsData.relationshipOwner : []}
                                              value={propsData.relationshipOwner.find(
                                                (obj) =>
                                                  obj._id === row.risk_owner
                                              )}
                                              optionLabel="label"
                                              placeholder="-- Please select --"
                                              className="w-150"
                                            />
                                          </td>
                                          <td className="flex gap-1">
                                            <InputIcon
                                              className="pi pi-eye ml-0"
                                              key={row._id}
                                              type="button"
                                              // icon="pi pi-eye"
                                              onClick={() =>
                                                handleOpenRiskIdentification(
                                                  row,
                                                  group
                                                )
                                              }
                                            />
                                            <InputIcon
                                              className="pi pi-pencil ml-10"
                                              type="button"
                                              // icon="pi pi-pencil"
                                              onClick={() =>
                                                handleEditRiskIdentification(
                                                  row,
                                                  group,
                                                  index
                                                )
                                              }
                                            />
                                          </td>
                                        </tr>
                                      ))
                                      : null}
                                  </React.Fragment>
                                ))}
                              </tbody>
                            </table>

                            <Paginator
                              first={first}
                              rows={rows}
                              totalRecords={totalRecords}
                              rowsPerPageOptions={[5, 10, 20, 50]}
                              onPageChange={onPageChange}
                            />
                          </div>
                        )}
                    </div>
                  </>
                )}
                {section.section_name === "Risk Management" && (
                  <>
                    <div>
                      {propsData.oppRisksTable?.find(
                        (table) => table.table_name === "Risk Management"
                      )?.status && (
                          <div className="group-table-data pl-0">
                            <table className="group-datatable">
                              <thead className="group-table-header">
                                <tr>
                                  {riskManagementColumns.map((headers) => (
                                    <th key={headers.header} className="width-12">{headers.header}</th>
                                  ))}
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody className="group-table-row">
                                {paginatedGroups.map((group) => (
                                  <React.Fragment key={group}>
                                    <tr>
                                      <td colSpan={9}>
                                        <b className="flex justify-content-md-start w-full">
                                          {group}
                                        </b>
                                      </td>
                                    </tr>
                                    {Array.isArray(riskGroups[group]) &&
                                      riskGroups[group].length > 0
                                      ? riskGroups[group].map((row, index) => (
                                        <tr key={`${group}-${index}`}>
                                          <td className="flex justify-content-md-start w-full width-12">
                                            <p>{row.risk_catLabel}</p>
                                          </td>
                                          <td className="width-12">
                                            <label title={row.risk_description}>
                                              {" "}
                                              {row.risk_description ||
                                                "N/A"}{" "}
                                            </label>
                                          </td>

                                          <td className="width-12">
                                            <DropdownElement
                                              onChange={(e) => {
                                                riskActionOwnerChange(
                                                  e,
                                                  row,
                                                  group,
                                                  index
                                                );
                                              }}
                                              id={row._id}
                                              key={row._id}
                                              options={(propsData.relationshipActionOwner != undefined && propsData.relationshipActionOwner.length > 0) ? propsData.relationshipActionOwner : []}
                                              value={propsData.relationshipActionOwner.find(
                                                (obj) =>
                                                  obj._id ===
                                                  row.action_owner
                                              )}
                                              optionLabel="label"
                                              placeholder="-- Please select --"
                                              className="w-150"
                                            />
                                          </td>
                                          <td className="width-12">
                                            <CalendarElement
                                              id="cost_base_date"
                                              className="ml-10"
                                              defaultValue={parseDateString(
                                                row?.action_bydate
                                              )}
                                              value={parseDateString(
                                                row?.action_bydate
                                              )}
                                              onChange={(e) => {
                                                riskActionByDate(e, row, group, index);
                                              }}
                                              maxLength="50"
                                              placeholder="Date"
                                              autocomplete="off"
                                            />
                                          </td>
                                          <td className="width-12">
                                            <label title={row.action_taken}>
                                              {" "}
                                              {row.action_taken || "N/A"}{" "}
                                            </label>
                                          </td>
                                          <td className="width-12">
                                            <label title={row.programme_impact}>
                                              {" "}
                                              {row.programme_impact ||
                                                "N/A"}{" "}
                                            </label>
                                          </td>
                                          <td className="width-12">
                                            <InputTextElementElement
                                              className="dropdown-field-handle"
                                              value={row.potential_saving}
                                              name="potential_saving"
                                              placeholder="Amount"
                                              onChange={(e) =>
                                                handlePotentialCostTextChange(
                                                  e,
                                                  row,
                                                  group,
                                                  index
                                                )
                                              }
                                            />
                                          </td>
                                          <td className="width-12">
                                            <InputTextElementElement
                                              className="dropdown-field-handle"
                                              value={row.actual_saving}
                                              name="actual_saving"
                                              placeholder="Amount"
                                              onChange={(e) =>
                                                handleActualCostTextChange(
                                                  e,
                                                  row,
                                                  group,
                                                  index
                                                )
                                              }
                                            />
                                          </td>
                                          <td className="width-12">
                                            <CheckboxElement
                                              checked={row.isCompleted}
                                              onChangeCheck={(e) =>
                                                riskCompleted(row, group, e, index)
                                              }
                                            ></CheckboxElement>
                                          </td>

                                          <td className="flex gap-1">
                                            <InputIcon
                                              className="pi pi-eye ml-0"
                                              key={row._id}
                                              type="button"
                                              // icon="pi pi-eye"
                                              onClick={() =>
                                                riskManagementModal(row, group)
                                              }
                                            />
                                            <InputIcon
                                              className="pi pi-pencil ml-10"
                                              type="button"
                                              // icon="pi pi-pencil"
                                              onClick={() =>
                                                editRiskManagementModal(
                                                  row,
                                                  group,
                                                  index
                                                )
                                              }
                                            />
                                          </td>
                                        </tr>
                                      ))
                                      : null}
                                  </React.Fragment>
                                ))}
                              </tbody>
                            </table>

                            <Paginator
                              first={first}
                              rows={rows}
                              totalRecords={totalRecords}
                              rowsPerPageOptions={[5, 10, 20, 50]}
                              onPageChange={onPageChange}
                            />
                          </div>
                        )}
                    </div>
                  </>
                )}

                {section.section_name === "Opportunity Identification" && propsData.oppRisksTable?.find(
                  (table) =>
                    table.table_name === "Opportunity Identification"
                )?.status && (
                    <div>
                      <div className="col pr-0 d-flex justify-end">
                        <ButtonElement
                          icon="pi pi-filter-slash"
                          className="edit-option-button font-text"
                          onClick={resetButton}
                        />
                        <div className="p-relative ml-20" ref={dropdownRef}>
                          <ButtonElement
                            className="edit-option-button"
                            type="button"
                            icon="pi pi-filter"
                            onClick={toggleDropdown}
                          />
                          {showDropdown && (
                            <>
                              <div className="s-field">
                                <div className="new-field w-100">
                                  <div className="form-group row align-items-center mb-0 mt-0">
                                    <div className="col-md-5 pl-0">
                                      <label className="form-label text-left">
                                        Action Owner:
                                      </label>
                                    </div>
                                    <div className="col pr-0">
                                      <MultiSelectElement
                                        value={selectedOwnerResp}
                                        optionLabel="label"
                                        options={actionOwnersFilter}
                                        placeholder="-- Please select --"
                                        maxSelectedLabels={1}
                                        onChangeValue={(e) =>
                                          handleSelection(e.value)
                                        }
                                        className="w-full"
                                      />
                                    </div>
                                  </div>
                                  <div className="form-group row align-items-center mb-0 mt-0">
                                    <div className="col-md-5 pl-0">
                                      <label className="form-label text-left">
                                        Status:
                                      </label>
                                    </div>
                                    <div className="col pr-0">
                                      <MultiSelectElement
                                        value={selectedStatus}
                                        optionLabel="label"
                                        options={statusFilter}
                                        placeholder="-- Please select --"
                                        maxSelectedLabels={1}
                                        onChangeValue={(e) =>
                                          handleStatusSelection(e.value)
                                        }
                                        className="w-full"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                          <ButtonElement
                            className="edit-option-button ml-20"
                            type="button"
                            icon="pi pi-trash"
                            onClick={deleteOppIdentification}
                          />
                          <ButtonElement
                            className="edit-option-button ml-20"
                            type="button"
                            icon="pi pi-plus"
                            onClick={addNewOppIdentify}
                          />
                        </div>
                      </div>
                      {propsData.oppRisksTable?.find(
                        (table) =>
                          table.table_name === "Opportunity Identification"
                      )?.status && (
                          <div>
                            <DataTable
                              value={opportunityIdentification}
                              columns={columns}
                              dataKey={"id"}
                              isNotReorder={true}
                              rowClick={rowClick}
                            />
                          </div>
                        )}
                    </div>
                  )}
                {section.section_name === "Opportunity Management" && (
                  <div>
                    {propsData.oppRisksTable?.find(
                      (table) => table.table_name === "Opportunity Management"
                    )?.status && (
                        <div>
                          <DataTable
                            value={opportunityIdentification}
                            columns={opportunityManagementColumns}
                            dataKey="_id"
                            isNewField={true}
                            rowClick={rowClick}
                          />
                        </div>
                      )}
                  </div>
                )}
              </AccordionTab>
            </Accordion>
          </div>
        );
      })}
      <Dialog
        header={`Opportunity Management : ${riskCategory.find(
          (obj) => obj._id === notIsCompletedData?.category
        )?.label
          }`}
        visible={notIsCompletedPopup}
        position={"right"}
        draggable={false}
        resizable={false}
        className="table-dialog width-50vw"
        onHide={closeNotIsCompletedPopup}
        footer={notIsCompletedFooter()}
      >
        <div className="confirmation-content">
          <span className="table-description">
            This action belongs to another user. Your are not authorised to complete this action.
          </span>
        </div>
      </Dialog>
      <Dialog
        header={`Risk Management : ${riskCategory.find(
          (obj) => obj._id === notIsCompletedData1?.risk_category
        )?.label
          }`}
        visible={notIsCompletedPopup1}
        position={"right"}
        draggable={false}
        resizable={false}
        className="table-dialog width-50vw"
        onHide={closeNotIsCompletedPopup1}
        footer={notIsCompletedFooter1()}
      >
        <div className="confirmation-content">
          <span className="table-description">
            This action belongs to another user. Your are not authorised to complete this action.
          </span>
        </div>
      </Dialog>
      <Dialog
        header={`Risk Management : ${riskCategory.find(
          (obj) => obj._id === isCompletedData1?.risk_category
        )?.label
          }`}
        visible={isCompletedPopup1}
        position={"right"}
        draggable={false}
        resizable={false}
        className="table-dialog width-50vw"
        onHide={closeIsCompletedPopup1}
        footer={isCompletedFooter1()}
      >
        <div className="confirmation-content">
          <span className="table-description">
            Do you want to complete this action?
          </span>
        </div>
      </Dialog>
      <Dialog
        header={`Opportunity Management : ${riskCategory.find(
          (obj) => obj._id === isCompletedData?.category
        )?.label
          }`}
        visible={isCompletedPopup}
        position={"right"}
        draggable={false}
        resizable={false}
        className="table-dialog width-50vw"
        onHide={closeIsCompletedPopup}
        footer={isCompletedFooter()}
      >
        <div className="confirmation-content">
          <span className="table-description">
            Do you want to complete this action?
          </span>
        </div>
      </Dialog>
      <Dialog
        header={`Risk Management : ${riskManagementGroup}`}
        visible={editRiskManagementModals}
        position={"right"}
        draggable={false}
        resizable={false}
        className="table-dialog width-50vw"
        onHide={closeEditRiskManagementModal}
        footer={renderRiskManagementFooter()}
      >
        <div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Risk Category:
              </label>
            </div>
            <div className="col pr-0">
              <label className="form-label text-left">{
                riskCategory.find(
                  (obj) => obj._id === riskManagement.risk_category
                )?.label
              }</label>
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Action Taken:
              </label>
            </div>
            <div className="col pr-0">
              <TextareaElement
                id="item_description"
                name="item_description"
                value={riskManagement.action_taken}
                onChange={(e) => {
                  handleRiskManagementActionTaken(e);
                }}
                //   register={register("summary.client_desc")}
                className="w-full"
                rows={3}
              />
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Programme Impact:
              </label>
            </div>
            <div className="col pr-0">
              <TextareaElement
                id="item_description"
                name="item_description"
                value={riskManagement.programme_impact}
                onChange={(e) => {
                  handleRiskManagementProgrammeImpact(e);
                }}
                //   register={register("summary.client_desc")}
                className="w-full"
                rows={3}
              />
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Comments:
              </label>
            </div>
            <div className="col pr-0">
              <TextareaElement
                id="item_description"
                name="item_description"
                value={riskManagement.comments}
                onChange={(e) => {
                  handleRiskManagementComments(e);
                }}
                //   register={register("summary.client_desc")}
                className="w-full"
                rows={3}
              />
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Status:
              </label>
            </div>
            <div className="col pr-0">
              <label className="form-label text-left">{(riskManagement?.isCompleted && "Completed") ||
                (riskManagement?.isCompleted === false && "Not Completed")}</label>
            </div>
          </div>
        </div>
      </Dialog>
      <Dialog
        header={`Risk Management : ${riskManagementGroup}`}
        visible={riskManagementModals}
        position={"right"}
        draggable={false}
        resizable={false}
        className="table-dialog width-50vw"
        onHide={closeRiskManagementModal}
        footer={renderFooterRiskManage()}
      >
        <div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Risk Category:
              </label>
            </div>
            <div className="col pr-0">
              <label className="form-label text-left">{
                riskCategory.find(
                  (obj) => obj._id === riskManagement.risk_category
                )?.label
              }</label>
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Action Taken:
              </label>
            </div>
            <div className="col pr-0">
              <label className="form-label text-left">{riskManagement.action_taken}</label>
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Programme Impact:
              </label>
            </div>
            <div className="col pr-0">
              <label className="form-label text-left">{riskManagement.programme_impact}</label>
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Comments:
              </label>
            </div>
            <div className="col pr-0">
              <label className="form-label text-left">{riskManagement.comments}</label>
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Status:
              </label>
            </div>
            <div className="col pr-0">
              <label className="form-label text-left">{(riskManagement?.isCompleted && "Completed") ||
                (riskManagement?.isCompleted === false && "Not Completed")}</label>
            </div>
          </div>
          {/* {selectedToView} */}
        </div>
      </Dialog>
      <Dialog
        header={`Opportunity Management`}
        visible={openOppManagement}
        position={"right"}
        draggable={false}
        resizable={false}
        className="table-dialog width-50vw"
        onHide={handleCloseOppManagement}
        footer={renderFooterCloseOpp()}
      >
        <div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Category:
              </label>
            </div>
            <div className="col pr-0">
              <label className="form-label text-left">{selectedOppManagementToView?.opp_CatLabel}</label>
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Action Taken:
              </label>
            </div>
            <div className="col pr-0">
              <label className="form-label text-left">{selectedOppManagementToView?.action_taken}</label>
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Programme Impact:
              </label>
            </div>
            <div className="col pr-0">
              <label className="form-label text-left">{selectedOppManagementToView?.programme_impact}</label>
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Comments:
              </label>
            </div>
            <div className="col pr-0">
              <label className="form-label text-left">{selectedOppManagementToView?.comments}</label>
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Status:
              </label>
            </div>
            <div className="col pr-0">
              <label className="form-label text-left">{(selectedOppManagementToView?.isCompleted &&
                "Completed") ||
                (selectedOppManagementToView?.isCompleted === false &&
                  "Not Completed")}</label>
            </div>
          </div>
        </div>
      </Dialog>
      <Dialog
        header={`Risk Management : ${selectedGroupToView}`}
        visible={openRiskIdentification}
        position={"right"}
        onHide={closeOpenRiskIdentification}
        draggable={false}
        resizable={false}
        className="table-dialog width-50vw"
        footer={renderFooterRiskMgmt()}
      >
        <div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Risk Category:
              </label>
            </div>
            <div className="col pr-0">
              <label className="form-label text-left">{
                riskCategory.find(
                  (obj) => obj._id === selectedRiskToView.risk_category
                )?.label
              }</label>
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Factors:
              </label>
            </div>
            <div className="col pr-0">
              <label className="form-label text-left">{selectedRiskToView.factor}</label>
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Risk Identification:
              </label>
            </div>
            <div className="col pr-0">
              <label className="form-label text-left">{selectedRiskToView.risk_description}</label>
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Consequence:
              </label>
            </div>
            <div className="col pr-0">
              <label className="form-label text-left">{selectedRiskToView.consequence}</label>
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Planned Action:
              </label>
            </div>
            <div className="col pr-0">
              <label className="form-label text-left">{selectedRiskToView.planned_action}</label>
            </div>
          </div>
          {/* {selectedToView} */}
        </div>
      </Dialog>
      <Dialog
        header={"Opportunity Identification"}
        visible={openOppIdentification}
        position={"right"}
        draggable={false}
        resizable={false}
        className="table-dialog width-50vw"
        onHide={closeOpenOppIdentification}
        footer={renderFooterOpenOpp()}
      >
        <div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Category:
              </label>
            </div>
            <div className="col pr-0">
              <label className="form-label text-left">{
                riskCategory.find(
                  (obj) => obj._id === selectedToView?.category
                )?.label
              }</label>
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Item Description:
              </label>
            </div>
            <div className="col pr-0">
              <label className="form-label text-left">{selectedToView.item_description}</label>
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Potential Advantage:
              </label>
            </div>
            <div className="col pr-0">
              <label className="form-label text-left">{selectedToView.consequence}</label>
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Planned Action:
              </label>
            </div>
            <div className="col pr-0">
              <label className="form-label text-left">{selectedToView.planned_action}</label>
            </div>
          </div>
          {/* {selectedToView} */}
        </div>
      </Dialog>
      <Dialog
        header={`Risk  Identification : ${selectedGroupToView}`}
        visible={openEditRiskIdentification}
        position={"right"}
        draggable={false}
        resizable={false}
        className="table-dialog width-50vw"
        onHide={closeEditRiskIdentification}
        footer={renderFooter()}
      >
        <div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Risk Category:
              </label>
            </div>
            <div className="col pr-0">
              <label className="form-label text-left"> {
                riskCategory.find(
                  (obj) => obj._id === selectedRiskToView.risk_category
                )?.label
              }</label>
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Factors:
              </label>
            </div>
            <div className="col pr-0">
              <label className="form-label text-left">{selectedRiskToView.factor}</label>
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Risk Description:
              </label>
            </div>
            <div className="col pr-0">
              <TextareaElement
                id="item_description"
                name="item_description"
                value={selectedRiskToView.risk_description}
                onChange={(e) => {
                  handleRiskIdentificationDescription(e);
                }}
                //   register={register("summary.client_desc")}
                className="w-full"
                rows={3}
              />
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Consequence:
              </label>
            </div>
            <div className="col pr-0">
              <TextareaElement
                id="item_description"
                name="item_description"
                defaultValue={selectedRiskToView.consequence}
                onChange={(e) => {
                  handleRiskIdentificationConsequence(e);
                }}
                //   register={register("summary.client_desc")}
                className="w-full"
                rows={3}
              />
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Planned Action:
              </label>
            </div>
            <div className="col pr-0">
              <TextareaElement
                id="item_description"
                name="item_description"
                defaultValue={selectedRiskToView.planned_action}
                onChange={(e) => {
                  handleRiskIdentificationPlannedAction(e);
                }}
                //   register={register("summary.client_desc")}
                className="w-full"
                rows={3}
              />
            </div>
          </div>
          {/* {selectedToView} */}
        </div>
      </Dialog>
      <Dialog
        header={"Opportunity Identification"}
        visible={openEditOppIdentification}
        position={"right"}
        draggable={false}
        resizable={false}
        className="table-dialog width-50vw"
        onHide={closeEditOppIdentification}
        footer={renderFooterEditOpp()}
      >
        <div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Category:
              </label>
            </div>
            <div className="col pr-0">
              <label className="form-label text-left">{
                riskCategory.find(
                  (obj) => obj._id === selectedToView.category
                )?.label
              }</label>
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Item Description:
              </label>
            </div>
            <div className="col pr-0">
              <TextareaElement
                id="item_description"
                name="item_description"
                value={selectedToView.item_description}
                onChange={(e) => {
                  setSelectedToView((prevData) => ({
                    ...prevData,
                    item_description: e.target.value
                  }))
                }}
                className="w-full"
                rows={3}
              />
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Potential Advantage:
              </label>
            </div>
            <div className="col pr-0">
              <TextareaElement
                id="consequence"
                name="consequence"
                value={selectedToView.consequence}
                onChange={(e) => {
                  setSelectedToView((prevData) => ({
                    ...prevData,
                    consequence: e.target.value
                  }))
                }}
                className="w-full"
                rows={3}
              />
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Planned Action:
              </label>
            </div>
            <div className="col pr-0">
              <TextareaElement
                id="planned_action"
                name="planned_action"
                value={selectedToView.planned_action}
                onChange={(e) => {
                  setSelectedToView((prevData) => ({
                    ...prevData,
                    planned_action: e.target.value
                  }))
                }}
                className="w-full"
                rows={3}
              />
            </div>
          </div>
          {/* {selectedToView} */}
        </div>
      </Dialog>
      <Dialog
        header={"Opportunity Management"}
        visible={openEditOppManagement}
        position={"right"}
        draggable={false}
        resizable={false}
        className="table-dialog width-50vw"
        onHide={closeEditOppManagement}
        footer={renderFooterEditManagement()}
      >
        <div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Category:
              </label>
            </div>
            <div className="col pr-0">
              <label className="form-label text-left">{
                riskCategory.find(
                  (obj) => obj._id === selectedToView1.category
                )?.label
              }</label>
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Action Taken:
              </label>
            </div>
            <div className="col pr-0">
              <TextareaElement
                id="item_description"
                name="item_description"
                value={selectedToView1.action_taken}
                onChange={(e) => {
                  setSelectedToView1((prevData) => ({
                    ...prevData,
                    action_taken: e.target.value
                  }))
                }}
                className="w-full"
                rows={3}
              />
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Programme Impact:
              </label>
            </div>
            <div className="col pr-0">
              <TextareaElement
                id="consequence"
                name="consequence"
                value={selectedToView1.programme_impact}
                onChange={(e) => {
                  setSelectedToView1((prevData) => ({
                    ...prevData,
                    programme_impact: e.target.value
                  }))
                }}
                className="w-full"
                rows={3}
              />
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Comments:
              </label>
            </div>
            <div className="col pr-0">
              <TextareaElement
                id="planned_action"
                name="planned_action"
                value={selectedToView1.comments}
                onChange={(e) => {
                  setSelectedToView1((prevData) => ({
                    ...prevData,
                    comments: e.target.value
                  }))
                }}
                className="w-full"
                rows={3}
              />
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left font-bold">
                Status:
              </label>
            </div>
            <div className="col pr-0">
              <label className="form-label text-left">{(selectedToView1?.isCompleted && "Completed") ||
                (selectedToView1?.isCompleted === false && "Not Completed")}</label>
            </div>
          </div>
          {/* {selectedToView} */}
        </div>
      </Dialog>
      <Dialog id="videoModal" visible={showVideo}
        breakpoints={{
          '1200px': '80vw',    // Larger modal on bigger screens
          '1024px': '85vw',    // Slightly smaller for medium screens
          '769': '90vw',     // Responsive on tablets
          '641px': '95vw',     // Almost full-width on mobile
        }}
        modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
      >
        <div className="video-overlay">
          <div className="video-container">
            <PlaylistVideos playlistId={process.env.REACT_APP_PORTFOLIO_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="risk" />
          </div>
        </div>
      </Dialog>
      <div className="cancel-footer mt-20">
        <div className='d-flex align-center justify-end pb-0'>
          <ButtonElement
            className="save-button"
            type="button"
            label={`Generate ${props.pipelineRisksubmodule} Report`}
            onClick={generateRiskReport1}
          />
        </div>
      </div>
    </>
  );
});

export default Risks;
